var en = {
	"header_logout": "Log out",
	"header_return_overview": "Return to overview",
	"header_welcome": "Welcome to interface of ",
	"header_account_status": "Account status",

	"menu_overview": "Overview",
	"menu_news": "News",
	"menu_search_order": "Search Order",
	"menu_update_information": "Account",
	"menu_account_estab_comercial": "Merchant Registration at CERC",
	"menu_account_cerc": "CERC",
	"menu_account_group": "Group",
	"menu_account_revenue_group": "Revenue Group",
	"menu_account_user": "Account - User",
	"menu_account_product": "Products",
	"menu_account_email": "E-mail/SMS Config",
	"menu_account_config": "Configuration",
	"menu_account_report": "Daily Report",
	"menu_account_fee": "Fee",
	"menu_account_custom": "Custom",
	"menu_account_user_config": "User Configuration",
	"menu_account_user_list": "Users",
	"menu_account_seller": "Sellers",
	"menu_account_shopify": "Shopify",
	"menu_pos_register": "POS Register",
	"menu_modelo_contrato": "Contract Model",

	"menu_super_config": "Super Config.",

	"menu_reports": "Reports",
	"menu_remittances": "Remittances",
	"menu_settlement_reports": "Settlement Reports",
	"menu_sales_reports": "Sales Reports",
	"menu_commission_reports": "Commission Reports",
	"menu_graphics": "Graphics",
	"menu_pixconfig": "Pix Configuration",
	"menu_blocklist_pix_roaming": "Blocklist Pix for international travelers",
	"menu_feesconfig": "Fees Configuration",
	"menu_resources": "Resources",
	"menu_checkout": "PB Checkout",
	"menu_offline_payment": "Payment Link",
	"menu_offline_payment_create": "Create",
	"menu_search_offline_payment": "Search",
	"menu_trial": "Trial",
	"menu_pagshield": "PagShield",
	"menu_ipn_history": "IPN History",
	"menu_ipn": "IPN",
	"menu_payout": "Payout",
	"menu_webhook": "Webhook",
	"menu_full_stats": "Stats",
	"menu_calendar": "Calendar",
	"menu_approval": "Approval",
	"menu_statistics": "Statistics by Order Date",
	"menu_statistics_payment": "Statistics by Payment Date",
	"menu_chargebacks": "Chargebacks",
	"menu_settlement": "Settlement",
	"menu_remittance": "Remittance",
	"menu_consolidated": "Consolidated",
	"menu_payout": "Payout",
	"menu_fee": "Fee",
	"menu_reserve": "Reserve",
	"menu_notafiscal": "Nota Fiscal",
	"menu_notafiscal_markup": "Nota Fiscal Markup",
	"menu_total_dia": "Total Today",
	"menu_forecast": "Forecast",
	"menu_forecast_compare": "Comparison",
	"menu_time": "Alert Report",
	"menu_payout_settings": "Settings",
	"menu_payout_payee": "Payees",
	"menu_payout_payout": "Payouts",
	"menu_payout_movement": "Pay-in/Payout",
	"menu_webhook_config": "Settings",
	"menu_webhook_history": "Webhook History",
	"menu_user": "User",
	"menu_permission": "Permission",
	"menu_especial_permission": "Special Permission",
	"menu_process_fees_title": "Process Fees",
	"menu_permission_group": "Permission Group",
	"menu_permission_merchant": "Permission Merchant",
	"menu_permission_campo": "Permission Fields",
	"menu_favorecido": "Customer List",
	"menu_log": "Log",
	"menu_refund_report": "Refund Report",
	"menu_revenue": "Revenue Report",
	"menu_revenuegrouprange": "Revenue Group Range",
	"menu_pod_report": "POD Report",
	"menu_gateway": "Gateway",
	"menu_pagshieldreport": "PagShield Report",
	"menu_remittance_report": "Report",
	"menu_products": "Products",
	"menu_auto_recurring_title": "PagStream",
	"menu_pagstream_products": "Products",
	"menu_auto_recurring_overview": "Overview",
	"menu_auto_recurring_automation": "Automation",
	"menu_auto_recurring_promotion": "Promotion Engine",
	"menu_auto_recurring_settings": "Settings",
	"menu_auto_recurring_rules": "Rules",
	"menu_auto_recurring_notification": "Notifications",
	"menu_auto_recurring_customer_area": "Subscriber Portal",
	"menu_auto_recurring": "Subscriptions",
	"menu_auto_recurring_frequency": "Billing Cycles",
	"menu_auto_recurring_shipping_cycle": "Shipping Cycles",
	"menu_auto_recurring_reports": "Reports",
	"menu_unidade_recebivel": "Receivables",
	"menu_pos_contratada": "Post-contracted",
	"menu_efeito_contrato": "Contracts in Effect",
	"menu_repasse_agendado": "Scheduled Remittance",
	"menu_antecipacao_repasse": "Remittance Anticipation",
	"menu_catalogo": "Product Catalog",
	"menu_catalogo_categoria": "Categories",
	"menu_catalogo_produto": "Products",
	"menu_fee_remittance": "Minimum Fee",
	"menu_remittance_proforma": "Proforma",
	"menu_remittance_proformapayment": "Proforma Payment",
	"menu_remittance_consolidatetaxid": "Consolidate TaxId",
	"menu_remittance_invoice": "Invoice",
	"menu_remittance_processment": "Processment",
	"menu_payment": "Payments",
	"menu_payment_history": "History",
	"menu_payment_setting": "Settings",
	"menu_payment_setting_config": "Connectors",
	"menu_payment_report": "Reports",
	"menu_cost_configuration": "Cost Configuration",
	"menu_payment_remittance": "Remittance",
	"menu_payment_invoice": "Invoice",
	"menu_invoice_payment": "Invoice Payment",

	"searchorder_title": "Search Order",
	"searchorder_ph_search": "Search",
	"searchorder_bt_search": "Search",
	"searchorder_bt_insert": "Insert Order",
	"searchorder_bt_export_csv": "Export to CSV",
	"searchorder_ph_search_start_date": "Start Date",
	"searchorder_ph_search_end_date": "End Date",
	"searchorder_order_number": "Order number",
	"searchorder_email_address": "E-mail address",
	"searchorder_submission_date": "Submission date",
	"searchorder_payment_date": "Payment date",
	"searchorder_internal_number": "Internal number",
	"searchorder_refund_date": "Refund date",
	"searchorder_td_order": "Order number",
	"searchorder_td_orders": "Orders",
	"searchorder_td_method": "Method",
	"searchorder_td_payment_method": "Payment method",
	"searchorder_td_payment_nupay_type": "Nupay payment type",
	"searchorder_td_date": "Date",
	"searchorder_td_submission_date": "Submission date",
	"searchorder_td_expiration_date": "Expiration date",
	"searchorder_td_payment_url": "Payment URL",
	"searchorder_td_boleto_url": "Boleto's URL",
	"searchorder_td_payment_url_short": "Short URL",
	"searchorder_td_action": "Action",
	"searchorder_td_status": "Status",
	"searchorder_td_status_new": "New status",
	"searchorder_td_status_old": "Old status",
	"searchorder_td_error": "Error code",
	"searchorder_td_abecs_code": "Error code brand",
	"searchorder_td_payment_date": "Payment date",
	"searchorder_td_payment_time": "Payment time",
	"searchorder_td_product": "Product(s)",
	"searchorder_td_product_service": "Product(s) / Service(s)",
	"searchorder_td_product_list": "Product List",
	"searchorder_td_customer_name": "Customer name",
	"searchorder_td_details": "Details",
	"searchorder_td_tax_id": "Tax ID",
	"searchorder_td_email": "E-mail",
	"searchorder_td_phone": "Phone",
	"searchorder_td_address": "Address",
	"searchorder_td_postal_code": "Postal code",
	"searchorder_td_city": "City",
	"searchorder_td_state": "State",
	"searchorder_td_amount": "Amount (BRL)",
	"searchorder_td_amount_due": "Amount due",
	"searchorder_td_amount_paid": "Amount paid",
	"searchorder_td_amount_refunded": "Amount refunded",
	"searchorder_td_sales_channel": "Sales channel",
	"searchorder_td_sales_channel_pl_api": "Payment Link (API)",
	"searchorder_td_sales_channel_dashboard": "Payment Link",
	"searchorder_td_sales_channel_remote": "Remote",
	"searchorder_td_sales_channel_pos": "SoftPOS",
	"searchorder_td_fee": "Fee",
	"searchorder_td_installments": "Installments",
	"searchorder_td_brand": "Brand",
	"searchorder_td_ccbrand": "Credit card brand",
	"searchorder_td_dcbrand": "Debit card brand",
	"searchorder_td_bbrand": "Issuing bank",
	"searchorder_td_brand_details": "Card details",
	"searchorder_td_ccdetails": "Credit card details",
	"searchorder_td_ccrestrition": "CC restriction",
	"searchorder_td_ccrestriction_block": "Blocked on:",
	"searchorder_td_ccrestriction_limit": "Unblock until:",
	"searchorder_td_ccrestriction_code": "Code:",
	"searchorder_td_score_pagshield": "Current PagShield score",
	"searchorder_td_pagshield_recommendation": "PagShield recommendation",
	"searchorder_td_pagshield_waiting_ps": "Analysis in progress. Please wait.",
	"searchorder_td_pagshield_recommendation2": "Pre-authorized due to the risk of fraud.",
	"searchorder_td_pagshield_recommendation_info": "The request must be manually reviewed to determine whether to capture or cancel it. For more information, please refer to the Manual Review of Pre-Authorized Orders under the \"Resources\" tab.",
	"searchorder_td_pagshield_history": "PagShield history",
	"searchorder_td_pagshield_fee": "PagShield fee (BRL)",
	"searchorder_td_auth_code": "Authorization code",
	"searchorder_td_soft_descriptor": "Soft descriptor",
	"searchorder_td_amount_refunded": "Amount refunded",
	"searchorder_td_refund_date": "Refund date",
	"searchorder_td_chargeback_info": "Chargeback info",
	"searchorder_td_refund_fee": "Refund fee",
	"searchorder_td_refund_info": "Refund information",
	"searchorder_td_recurring": "Recurring",
	"searchorder_td_auth": "Auth",
	"searchorder_td_url_retorno": "Return URL",
	"searchorder_td_customized_exp": "Customized expiration",
	"searchorder_td_default_exp": "Default expiration",
	"searchorder_td_internal_number": "Internal number",
	"searchorder_td_operation_log": "Operation log",
	"searchorder_td_pix_auto": "Automatic Pix",
	"searchorder_id_pix_auto": "Identifier",
	"searchorder_desc_pix_auto": "Description",
	"searchorder_cycle_pix_auto": "Cycle",
	"searchorder_expir_pix_auto": "Expiration",
	"searchorder_first_pix_auto": "First charge",
	"searchorder_min_pix_auto": "Minimum amount",
	"searchorder_code_pix_auto": "Code",
	"searchorder_bank_pix_auto": "Bank",
	"searchorder_ispb_pix_auto": "ISPB",
	"searchorder_bank_not_found_pix_auto": "Bank not found",
	"searchorder_ispb_not_found_pix_auto": "ISPB not found",
	"searchorder_error_pix_auto": "Error message",
	"searchorder_td_title_number": "Payment ID",
	"searchorder_td_extra_param": "Extra parameters",
	"searchorder_td_boleto_by": "Boleto via",
	"searchorder_due_date_in": "Due in",
	"searchorder_extend_expiration_date": "Extend expiration date",
	"searchorder_extend_expiration_date_by": "Extend expiration date by",
	"searchorder_extend_expiration_period": "Extend the expiration period by",
	"searchorder_extend_expiration_period_boleto": "Extend the expiration date to",
	"searchorder_extend_expiration_invalid": "Invalid extension period",
	"searchorder_extend_expiration_success": "Expiration date extended",
	"searchorder_currency_usd": "USD",
	"searchorder_currency_eur": "EUR",
	"searchorder_currency_brl": "BRL",
	"searchorder_currency_ars": "ARS",
	"searchorder_waiting_for_payment": "Waiting for payment",
	"searchorder_failed": "Failed",
	"searchorder_completed": "Completed",
	"searchorder_captured": "Capture",
	"searchorder_cancel": "Cancel",
	"searchorder_refund": "Request Refund",
	"searchorder_refund_adicional": "Request Additional Refund",
	"searchorder_chargeback": "Chargeback",
	"searchorder_searchon": "Search on",
	"searchorder_update": "Update on",
	"searchorder_revert_refund": "Revert Refund",
	"searchorder_note_bank_acc": "Note: The bank account holder must be the customer, and not a third-party.",
	"searchorder_bank": "Bank",
	"searchorder_branch": "Branch",
	"searchorder_account": "Account",
	"searchorder_account_type": "Account Type",
	"info_bank_group_pix": "If the bank is not listed, it is not part of Pix participants group.",

	"searchorder_refund_pix_type": "Pix",
	"searchorder_refund_ted_type": "TED",
	"searchorder_refund_transfer_type": "Transfer type",
	"searchorder_customer_pix_key_type": "Pix key type",
	"searchorder_customer_pix_key": "Pix key",

	"refund_pix_key_type_phone": "Phone",
	"refund_pix_key_type_taxid": "Tax ID",
	"refund_pix_key_type_email": "E-mail",
	"refund_pix_key_type_alternative": "Alternative",

	"searchorder_action_edit": "Edit",
	"searchorder_action_delete": "Delete",
	"searchorder_action_recreate": "Recreate",
	"searchorder_amount_tobe_refund": "Amount to be refunded",
	"searchorder_fx_rate_refund": "Estimated amount in ",
	"searchorder_nav_prev": "PREVIOUS",
	"searchorder_nav_next": "NEXT",
	"searchorder_suspected_fraud": "Suspected fraud",
	"searchorder_action_available": "No Action Available",
	"searchorder_export_without_filter": "Please filter by order, e-mail, submission date, payment date or refund date to generate a report to be exported.",
	"searchorder_status_boleto": "Status Boleto",
	"searchorder_status_pix": "Pix Data",
	"searchorder_boleto_short": "Boleto short",
	"searchorder_add_payment_link": "Create Payment Link",
	"searchorder_add_new_order": "Create New Order",
	"searchorder_order_created": "Order created",
	"searchorder_cancel_order": "Cancel",
	"searchorder_refund_order": "Set order as refunded (RP)",
	"searchorder_cc_updated": "CC Updated.",
	"searchorder_pix_code": "Pix code",
	"searchorder_pix_img": "Pix QR code",
	"searchorder_ordem_remittance": "Scheduled remittance",

	"searchorder_processing_in": "Processed in",
	"searchorder_payment_status": "Payment status",
	"searchorder_recurring_only": "Recurring only",
	"searchorder_pm_bank_transfer":"Bank Transfer/Deposit",
	"searchorder_pm_credit_card": "Credit card",
	"searchorder_pm_debit_card": "Debit card",
	"searchorder_pm_other": "Other",

	"searchorder_status_pay_completed": "Payment completed",
	"searchorder_status_waiting_payment": "Waiting for payment",
	"searchorder_status_refund_requested": "Refund requested",
	"searchorder_status_pre_authorized": "Payment pre-authorized",
	"searchorder_status_payment_failed": "Payment failed",
	"searchorder_status_refund_processed": "Refund processed",
	"searchorder_status_pb_debit_credit": "PagBrasil debit/credit",
	"searchorder_status_payment_rejected": "Payment rejected",
	"searchorder_status_chargeback": "Chargeback",

	"searchorder_status_listagem_pay_completed": "Completed",
	"searchorder_status_listagem_waiting_payment": "Waiting for payment",
	"searchorder_status_listagem_waiting_payment_cc": "Payment requested",
	"searchorder_status_listagem_refund_requested": "Refund requested",
	"searchorder_status_listagem_pre_authorized": "Pre-authorized",
	"searchorder_status_listagem_payment_failed": "Failed",
	"searchorder_status_listagem_refund_processed": "Refund processed",
	"searchorder_status_listagem_pb_debit_credit": "PagBrasil debit/credit",
	"searchorder_status_listagem_payment_rejected": "Rejected",
	"searchorder_status_listagem_chargeback": "Chargeback",

	"searchorder_status_log_refund_rejected": "Refund rejected",
	"searchorder_status_log_captured_order": "Capture requested",
	"searchorder_status_log_refund_requested": "Refund requested",
	"searchorder_status_log_cancelled_order": "Cancel requested",
	"searchorder_status_log_rejected": "Cancel requested",

	"searchorder_status_listagem_full_pay_completed": "Payment completed",
	"searchorder_status_listagem_full_waiting_payment": "Waiting for payment",
	"searchorder_status_listagem_full_waiting_payment_cc": "Payment requested but not processed yet",
	"searchorder_status_listagem_full_refund_requested": "Refund requested",
	"searchorder_status_listagem_full_pre_authorized": "Payment pre-authorized but not captured yet",
	"searchorder_status_listagem_full_payment_failed": "Payment failed",
	"searchorder_status_listagem_full_refund_processed": "Refund processed",
	"searchorder_status_listagem_full_pb_debit_credit": "PagBrasil debit/credit",
	"searchorder_status_listagem_full_payment_rejected": "Payment rejected",
	"searchorder_status_listagem_full_chargeback": "Chargeback",

	"searchorder_invalid_order": "Invalid character in parameter 'order'.",
	"searchorder_empty_order": "Please complete the field 'order'.",
	"searchorder_empty_product": "Please complete the field 'product'.",
	"searchorder_empty_amount": "Please complete the field 'amount'.",
	"searchorder_empty_installments": "Please complete the field 'installments'.",
	"searchorder_amount_limit": "Invalid amount.",

	"searchorder_cancel_order_msg_pec": "Please confirm you want to cancel this payment request. Once cancelled, your customer will not be able to pay the PEC Flash® transaction because the request is removed from the lottery agencies' system in real time.",
	"searchorder_cancel_order_msg_bol": "Please confirm you want to cancel this payment request. Once cancelled, your customer will not be able to view the boleto anymore.",
	"searchorder_cancel_order_msg_del": "Please confirm you want to delete this order.",

	"searchorder_refund_modal_title" : "Request Refund",
	"searchorder_refund_ckbox_tooltip": "Please check this box if you are refunding this order because of suspected fraud. The information feeds into our fraud prevention system and helps PagShield users to avoid future fraud.",

	"searchorder_multi_shipping_refund_title": "Multi Shipping Refund",
	"searchorder_multi_shipping_refund_description": "This order has multiple distribution centers. Select refund values for each item individually.",
	"searchorder_multi_shipping_refund_note": "Only selected items with informed values will be processed for refund.",
	"searchorder_multi_shipping_summary_title": "Multi Shipping Refund Summary",
	"searchorder_multi_shipping_summary_description": "Confirm selected refunds before proceeding.",
	"searchorder_multi_shipping_summary_warning": "This action cannot be undone. Only confirm if the values are correct.",
	"searchorder_continue": "Continue",
	"searchorder_confirm_refund": "Confirm Refund",
	"searchorder_total_refund": "Total Refund",
	"searchorder_enter_refund_amount": "Enter amount",
	"searchorder_product_s": "product(s)",
	"searchorder_process_multi_shipping": "Process Multi Shipping Refund",

	"searchorder_saldo_insuficiente": "Insufficient balance for refund.",
	"searchorder_chargeback_requested": "Refund not allowed. Chargeback requested.",

	"searchorder_title_order_data": "ORDER",
	"searchorder_title_customer_data": "CUSTOMER",
	"searchorder_title_payment_information": "PAYMENT INFORMATION",
	"searchorder_title_other_information": "OTHER INFORMATION",
	"searchorder_title_beneficiary_information": "BENEFICIARY",

	"searchorder_resend_ipn": "Resend IPN",
	"searchorder_complete_payment": "Complete payment",

	"search_paymentlink_code": "Payment Link code",
	"search_paymentlink_payment_options": "Payment options",
	"search_paymentlink_url_return": "Return URL",
	"search_paymentlink_export_without_filter": "Please filter by order, e-mail, taxid or submission date to generate a report to be exported.",
	"search_paymentlink_pm_empty": "Not informed",
	"search_paymentlink_pm_empty_info": "Not informed, all payment methods available will be included.",
	"search_paymentlink_goto_searchorder": "Search Order",
	"search_paymentlink_status_pending": "Pending",
	"search_paymentlink_status_completed": "Completed",
	"search_paymentlink_status_expired": "Expired",
	"search_paymentlink_status_open": "Open",
	"search_paymentlink_status_canceled": "Canceled",
	"search_paymentlink_cancel_order_msg": "Do you want to cancel this order?",
	"search_paymentlink_extend_period_to" : "Extend the expiration period to",
	"search_paymentlink_extend_to" : "Extend to",
	"search_paymentlink_choice_date" : "Choose a date",

	"option_order_template" : "Template",
	"option_update_order_no_template" : "No template",
	"option_update_order_chargeback_penalty_fee" : "Chargeback penalty fee",
	"option_update_order_chargeback_reversal" : "Chargeback reversal",
	"option_update_order_double_payment" : "Double payment",
	"option_update_order_payout_value_retention" : "Payout balance transfer - Value retention",
	"option_update_order_payout_value_release" : "Payout balance transfer - Value release",
	"option_update_order_process_administrative_fee" : "Lawsuit charges - Administrative fee",
	"option_update_order_process_fee" : "Lawsuit charges - Fees",
	"option_update_order_process_sentence" : "Lawsuit charges - Judgments",
	"option_update_order_process_procon" : "Lawsuit charges - PROCONS",
	"option_update_order_gateway_fee" : "Gateway Fee",
	"option_update_order_remittance_fee" : "Remittance Fee",
	"option_update_order_anticipation_of_receivables" : "Anticipation of receivables",
	"option_update_order_termination_fee" : "Termination fee",

	"ui_title": "Account",
	"ui_main": "Main",
	"ui_label_name": "Name",
	"ui_label_user": "User",
	"ui_label_group": "Group",
	"ui_label_account_group_info": "Account group info",
	"ui_label_secretphrase": "Secret Phrase",
	"ui_label_token": "Token",
	"ui_label_sessionid": "Session ID",
	"ui_label_ipn_url": "IPN URL",
	"ui_label_additional_url": "Additional URL",
	"ui_label_api_response_type": "API response type",
	"ui_label_ipn_response_type": "IPN response type",
	"ui_label_ipn_asynchronous": "IPN asynchronous",
	"ui_label_ipn_placeholder": "URL you want PagBrasil to send payment confirmations",
	"ui_label_HMAC_key": "HMAC-MD5 key",
	"ui_label_default_soft_desc": "Default soft descriptor",
	"ui_label_information_boleto": "Information in the boleto",
	"ui_label_information_boleto_opt1": "Include order number in the boleto description",
	"ui_label_information_boleto_opt2": "Include order number and product name in the boleto description",
	"ui_label_maximum_number": "Maximum number of installments",
	"ui_label_min_value_installment": "Minimum value per installment",
	"ui_error_min_value_installment": "The minimum value of a installment is 5.00",
	"ui_label_boleto_bancario": "Boletos bancários valid for",
	"ui_label_pec_valid_for": "PEC Flash valid for",
	"ui_label_pix_valid_for": "Pix valid for",
	"ui_label_pix_fluxo": "Main Bank",
	"ui_label_merchant_type": "Type",
	"ui_tooltip_pix_fluxo": "",
	"ui_label_payment_link_valid": "Payment link valid for",
	"ui_label_payment_link_valid_date": "Payment link valid until",
	"ui_label_automatic_cancel": "Automatic cancellation",
	"ui_label_automatic_cancel_day": "Business days after expiration, to cancel",
	"ui_label_pix_ipn_payer": "Payer info on IPN",
	"ui_label_pix_informacao_pagador": "Replace payer info",
	"ui_label_pix_itp_open_finance": "Open Finance",
	"ui_label_pix_descriptor": "Prefix added to the descriptor",
	"ui_label_date_decimal_format": "Date and decimal format",
	"ui_label_language": "Language",
	"ui_label_language_en": "English",
	"ui_label_language_pt": "Portuguese",
	"ui_label_suport_information": "Support/contact information on boleto bancário (in Portuguese)",
	"ui_label_suport_information_table": "Information on boleto",
	"ui_label_payment": "Payments",
	"ui_label_authorized_payment": "Authorized Payments",
	"ui_label_payment_alert": "Payment Alert",
	"ui_label_payment_discount": "Payment Discount",
	"ui_label_payment_discount_range": "Discount Range",
	"ui_label_payment_discount_range_duplicated": "Duplicated value.",
	"ui_label_payment_discount_from": "From",
	"ui_label_payment_discount_to": "To",
	"ui_label_discount_type": "Discount type",
	"ui_label_value": "Value",
	"ui_label_fixed_amount": "Fixed amount",
	"ui_label_percentage": "Percentage",
	"ui_label_pagshield": "PagShield",
	"ui_label_pagshield_premium": "PagShield Premium",
	"ui_label_fraud_screening": "Fraud screening",
	"ui_label_pre_auth_screening": "Fraud screening of pre-authorization orders",
	"ui_label_pre_auth_screening_at_creation": "At creation",
	"ui_label_pre_auth_screening_on_demand": "On demand",
	"ui_label_anti_fraud_service": "Anti-fraud service ID",
	"ui_label_paypal": "PayPal",
	"ui_label_nupay": "NuPay",
	"ui_label_taxa": 'Fees',
	"ui_label_fee": "Fee",
	"ui_label_fee_premium": "Fee Premium",
	"ui_label_fix_premium": "Fix Premium",
	"ui_label_public_key": "Public Key",
	"ui_label_public_key_info": "Used only on the Payment Link page.",
	"ui_label_gateway": "Gateway",
	"ui_label_settlement_cobranca": "Payment Method",
	"ui_label_settlement_cobranca_merchant": "Charge from Merchant Account",
	"ui_label_gateway_cobranca": "Monthly fee payment setup",
	"ui_label_gateway_cobranca_boleto": "Boleto",
	"ui_label_gateway_cobranca_merchant": "Charge from the following merchant account",
	"ui_label_fix": "Fix",
	"ui_label_wallet_markup": "Digital wallet solution",
	"ui_label_fix_token": "Fix (Token)",
	"ui_label_number_transaction": "Number of transactions >=",
	"ui_label_number_transaction_token": "Number of transactions >= (Token)",
	"ui_label_apply_the_fix": "Apply the fix of",
	"ui_label_apply_the_fix_token": "Apply the fix of (Token)",
	"ui_label_key": "Key",
	"ui_label_terminal_id": "Terminal ID",
	"ui_label_partner_id": "Partner ID",
	"ui_label_authentication": "Authentication",
	"ui_label_create_date": "Creation date",
	"ui_label_processing_start_date": "Processing start date",
	"ui_value_disable_auto_renew": "Disable auto-renew",
	"ui_badge_important": "Important",
	"ui_badge_important_boleto_email": "The merchant must be aware about the auto-renew option. Disabling this feature doesn't stop the reminders. To stop the reminders go to the group \"FUNCTIONALITIES\" option \"E-mail Boleto\".",
	"ui_badge_important_boleto_sms": "The merchant must be aware about the auto-renew option. Disabling this feature doesn't stop the reminders. To stop the reminders go to the group \"FUNCTIONALITIES\" option \"SMS Boleto\".",
	"ui_label_reimburse_fee": "Reimburse Fee",
	"ui_label_return_transaction_fee": "Return transaction fee",
	"ui_label_between": "Between",
	"ui_append_days": "day(s)",
	"ui_append_hours": "hour(s)",
	"ui_append_minutes": "minute(s)",
	"ui_label_and": "And",
	"ui_label_refund_after": 'Refund after',
	"ui_label_and_before": 'and before',
	"ui_label_valid_for": "Valid for",
	"ui_label_functionalities": "Functionalities",
	"ui_label_call_using": "Call using",
	"ui_label_require_pagshield": "Require PagShield credit card analysis",
	"ui_label_recurring_cc": "Recurring credit card",
	"ui_label_recurring_inst": "Recurring installments",
	"ui_label_check_taxid": "Check Taxid",
	"ui_label_settlement_report_option": "Settlement Report Option",
	"ui_label_boleto_flash": "Boleto Flash",
	"ui_label_pix_internacional": "Pix for International Payments",
	"ui_label_pec_flash": "PEC Flash",
	"ui_label_force_pbtoken": "Force Pbtoken",
	"ui_label_invoice_date": "Invoice date",
	"ui_label_https_boleto": "HTTPS Boleto",
	"ui_label_email_boleto": "Boleto e-mail",
	"ui_label_email_pec": "PEC Flash e-mail",
	"ui_label_email_pagamento": "Payment completed e-mail",
	"ui_label_email_pos": "Payment receipt POS",
	"ui_label_email_pagshopify": "Shopify payment e-mail",
	"ui_label_soft_desc_placeholder": "Soft Descriptor Placeholder",
	"ui_label_sms_consumido": "SMS package balance",
	"ui_label_email_consumido": "E-mail package balance",
	"ui_label_email_from": "From",
	"ui_label_email_assunto": "Subject",
	"ui_label_email_template": "Template",
	"email_pos_fx_amount": "Amount currency",
	"email_pos_fx_rate": "Exchange rate",
	"email_pos_fx_currency": "Transaction currency",
	"email_pos_template_iof": "IOF",
	"email_template": "Template",
	"sms_template": "Template",
	"available_placeholders": "Available placeholders",
	"ui_email_pagamento": "Payment",
	"ui_email_pagamento_shopify": "Shopify Payment",
	"ui_email_cancel": "Cancel order",
	"ui_empty_template": "Template not configured",
	"ui_template": "Configure the template",
	"ui_email_sms_confirmation": "Confirmation",
	"ui_email_sms_reminder": "Reminder",
	"ui_email_sms_both": "Both",
	"ui_email_sms_package": "Package",
	"ui_email_sms_send_test": "E-mail test",
	"ui_email_sms_email_sent": "E-mail sent",
	"email_use_template": "Use template default",
	"voce_deseja_aplicar_template_default": "Do you want substitute the current template by the default?",

	"ui_label_webhook_payout": "Payout",
	"ui_label_payoutNotification": "Payout notification",
	"ui_label_payoutResend": "Auto resend",
	"ui_label_sendFormat": "Sending format",
	"ui_label_urlWebhook": "Webhook URL",
	"ui_search_webhook": "Search Webhook",
	"ui_unsuccessful_webhook": "List all unsuccessful webhooks",
	"ui_details_webhook": "View/Resend Webhook",
	"ui_status_success_webhook": "Success",
	"ui_status_fail_webhook": "Fail",
	"ui_status_notcomp_webhook": "Not Compliant",
	"ui_clickhere_webhook": "Click here to see",
	"ui_content_webhook": "Content",
	"ui_previous_webhook": "Previous",
	"ui_next_webhook": "Next",
	"ui_refresh_webhook": "Refresh",
	"ui_resend_webhook": "Resend Webhook",
	"ui_label_system": "System",
	"ui_label_json": "JSON",
	"ui_label_post": "POST",
	"ui_label_xml": "XML",
	"ui_label_plain": "Plain text",
	"ui_label_date_send": "Date",
	"tooltip_payout_resendGroup": 'If the webhook fails our system will e-mail your technical contact a warning notification (subject "Urgent: Error posting webhook"). If you activate the auto resend, our system will then try to resend failed webhook as follows: - The next 7 attempts will take place every 7 minutes.- The next 23 attempts will take place every 60 minutes. If the last attempt of sending the webhook fails, our system will e-mail another warning notification (subject "Urgent: Error posting webhook").',
	"tooltip_pagstream_resendGroup": 'If the webhook fails our system will e-mail your technical contact a warning notification (subject "Urgent: Error posting webhook"). If you activate the auto resend, our system will then try to resend failed webhook as follows: - The next 7 attempts will take place every 7 minutes.- The next 23 attempts will take place every 60 minutes. If the last attempt of sending the webhook fails, our system will e-mail another warning notification (subject "Urgent: Error posting webhook").',
	"tooltip_payment_resendGroup": 'If the webhook fails our system will e-mail your technical contact a warning notification (subject "Urgent: Error posting webhook"). If you activate the auto resend, our system will then try to resend failed webhook as follows: - The next 7 attempts will take place every 7 minutes.- The next 23 attempts will take place every 60 minutes. If the last attempt of sending the webhook fails, our system will e-mail another warning notification (subject "Urgent: Error posting webhook").',
	"tooltip_prov_edit": "Customized",
	"webhook_resend_confirm_part1": "Please press OK to repost webhook ID ",
	"webhook_resend_confirm_part2": " to your server.",

	"ui_label_webhook_pagstream": "PagStream",
	"ui_label_pagstreamNotification": "PagStream notification",
	"ui_label_pagstream_shipping_notification": "Shipping notification",
	"ui_label_pagstreamResend": "Auto resend",
	"ui_label_pagstream_product_notification": "Product rule update notification",

	"ui_label_webhook_pix": "Automatic Pix",
	"ui_label_pix_notification": "Automatic Pix consent notification",
	"ui_label_pix_resend": "Auto resend",
	"ui_label_pix_settings_webhook": "Webhook URL",

	"ui_label_webhook_payment": "Payments",
	"ui_label_paymentNotification": "Payment notification",
	"ui_label_paymentResend": "Auto resend",

	"ui_label_webhook_order": "Order",
	"ui_label_order_notification": "Order status notification",
	"ui_label_order_resend": "Auto resend",
	"ui_label_order_settings_webhook": "Webhook URL",

	"ui_recurring_template_table": "Templates of e-mails to customers",

	"ui_email_create_recurring": "Activation - New Subscription",
	"ui_email_reminder_recurring": "Credit Card Billing Reminder",
	"ui_email_reminder_recurring_adicional": "Payment Link Billing Reminder",
	"ui_email_billing_recurring": "Payment Link Billing",
	"ui_email_billing_confirmation": "Billing Confirmation",
	"ui_email_cancel_recurring": "Subscription Cancellation Confirmation",
	"ui_email_subscriptionupdate": "Subscription Update Confirmation",
	"ui_email_subscriptionpaused": "Subscription Paused Confirmation",
	"ui_email_reactivate": "Subscription Reactivation",

	"ui_label_link_version": "Link version",
	"ui_label_sms_boleto": "SMS boleto",
	"ui_label_sms_pec": "SMS PEC",
	"ui_label_iframe_signature": "Iframe signature",
	"ui_label_boleto_node_limit": "Boleto node limit (XML)",
	"ui_label_boleto_failed_cc": "Block failed CC for",
	"ui_label_blockr": "Block refund",
	"blockr_tooltip": "This feature applies to all payment methods.",
	"ui_label_block_real_cc": "Block real CC",
	"ui_label_set_cc_pf": "Set CC PF",
	"ui_label_cc_info_ipn": "CC info on IPN",
	"ui_label_block_pagshield_amount": "Block PagShield amount",
	"ui_label_export_report_option": "Export report type",
	"ui_label_despacho_postal": "Pre-paid Despacho Postal",
	"ui_label_despacho_postal_desc": "Postal handling fee",
	"ui_label_email_notificacao_cef": "Alert PEC Flash registration",
	"ui_label_auto_recurring": "PagStream",
	"ui_label_customer_area": "Subscriber Portal",
	"ui_label_customer_area_add_product": "Drag products here to add to Subscriber Portal",
	"ui_label_customer_area_remove_product": "Drag products here to remove from Subscriber Portal",
	"ui_label_customer_area_available_products": "Available for subscriptions in the Subscriber Portal ",
	"ui_label_single_purchase": "Available for a one-time purchase in the Subscriber Portal",
	"ui_label_creation_rule": "Create subscription from an order addition",
	"ui_label_pagstream_premium": "PagStream Premium",
	"ui_label_pagstream_by_sku": "Rule by SKU",
	"ui_label_pagstream_subscription_creation": "Create subscriptions on",
	"ui_label_pagstream_subscription_creation_order_approval": "Order approval",
	"ui_label_pagstream_subscription_creation_demand": "Demand",
	"ui_label_pagstream_recharge_automatically": "Retry to charge automatically",
	"ui_label_pagstream_subscription_info_wh": "Subscription info on webhook",
	"ui_label_pagstream_shippings": "Split delivery based on a shipping cycle",
	"ui_label_auto_rec_email_cancel": "Notification when a subscription is cancelled",
	"ui_label_all_info_boleto": "All info on Boleto",
	"ui_label_remittance_type": "Remittance type",
	"ui_label_remittance_agent": "Remittance agent",
	"ui_label_boleto_pay_number": "Boleto's barcode number",
	"ui_label_email_payment_link": "Payment Link e-mail",
	"ui_label_more": "More",
	"ui_label_frequencia": "Settlement cycle",
	"ui_label_frequencia_juros": "Interest cycle",
	"ui_label_remessa": "Remittance",
	"ui_label_pay_in_account": "Pay-in account (no remittance)",
	"ui_label_account_type": "Account type",
	"ui_label_currency_type": "Currency",
	"ui_label_greater_than_zero": "Greater than zero",
	"ui_label_chargeback": "Chargeback fee",
	"ui_label_chargeback_tipo": "Chargeback fee type",
	"ui_label_spread_pix": "Spread on the transaction amount",
	"ui_label_spread": "Spread on the transaction amount (as fee)",
	"ui_label_spreadpos": "Spread on the net amount (at the exchange)",
	"ui_label_fx_rate_assured": "Moment the exchange rate is secured",
	"ui_label_fx_rate_assured_spread": "Spread to be added on the current exchange rate (PC/CD)",
	"ui_label_fx_rate_assured_spread_risk": "Additional spread to be added when exchange rate is not current (PC/CD)",
	"ui_label_fx_rate_fix": "Fixed fees in USD/EUR",
	"ui_label_fx_rate_assured_spread_refund": "Spread to be subtracted on the current exchange rate (RP/CB)",
	"ui_label_fx_rate_assured_spread_risk_refund": "Additional spread to be subtracted when exchange rate is not current (RP/CB)",
	"ui_label_spread_payment": "Spread to be subtracted on the current exchange rate",
	"ui_label_spread_risk_payment": "Additional spread to be subtracted when exchange rate is not current",
	"ui_label_min_remittance": "Minimum remittance",
	"ui_label_balance_yesterday": "Balance from yesterday",
	"ui_label_reserve_of": "Reserve of",
	"ui_label_reserve_type": "Reserve type",
	"ui_label_reserve_type_variable": "Variable",
	"ui_label_reserve_type_fixed": "Fixed",
	"ui_label_last": "Last",
	"ui_label_reserve_complement": "Reserve complement",
	"ui_label_remittance_currency": "Remittance currency",
	"ui_label_remittance_fee": "Remittance fee",
	"ui_label_technical_contact_email": "Technical contact e-mail(s)",
	"ui_label_operational_contact_email": "Operational contact e-mail(s)",
	"ui_label_refund_contact_email": "Revert Refund/Chargeback contact e-mail(s)",
	"ui_label_contract_notification_email": "Contact for contract-related notifications e-mail(s)",
	"ui_label_news_contact_email": "News contact e-mail(s)",
	"ui_label_pod_manager": "Shipping/PODs manager",
	"ui_label_support": "End customer support channel",
	"ui_label_store_name": "Store name",
	"ui_label_support_email": "Support E-mail",
	"ui_label_store_url": "Store URL",
	"ui_label_extra_info": "Extra information",
	"ui_label_partnership": "Partnership",
	"ui_label_risk_rating": "Risk rating",
	"ui_label_risk_rating_option_low": "Low",
	"ui_label_risk_rating_option_medium": "Medium",
	"ui_label_risk_rating_option_high": "High",
	"ui_label_touch_rating": "Revenue rating",
	"ui_label_compliance_info": "Compliance info",
	"ui_label_additional_information_payment_link": "Additional information on the Payment Link page (footer)",
	"ui_label_maintenance": "Maintenance",
	"ui_label_min_fee": "Maintenance Minimum Fee",
	"ui_label_min_fee_pagstream": "PagStream® Maintenance Minimum Fee",
	"ui_label_start_date_charging": "Start date for charging the min. fee",
	"ui_label_fee_text": "Fee text (max. 200 char)",
	"ui_label_plugin": "Plugin",
	"ui_label_solution_fee": "PagBrasil Solution Fee",
	"ui_label_total_amt_fee": "Amount fee",
	"ui_label_fee_revenuef": "(revenue)",
	"ui_label_fee_revenuep": "PagStream® Service Fee",
	"ui_label_router_function": "Router function",
	"ui_label_report": "Report",
	"ui_label_daily_report": "Daily report",
	"ui_label_pix_roaming_report": "Pix for international travelers report",
	"ui_label_settlement_report": "Settlement report",
	"ui_label_send_email": "E-mail",
	"ui_label_sftp": "SFTP",
	"ui_label_sftp_url": "SFTP URL",
	"ui_label_sftp_port": "SFTP port",
	"ui_label_sftp_username": "SFTP username",
	"ui_label_sftp_password": "SFTP password",
	"ui_label_sftp_path": "SFTP path",
	"ui_label_daily_report_option": "Daily report option",
	"ui_label_daily_taxid": "Tax ID",
	"ui_label_daily_commission_id": "Comission ID (Computop)",
	"ui_label_daily_translate_payment": "Payment method (full text)",
	"ui_label_daily_translate_status": "Order status (full text)",
	"ui_label_send_ipn_credentials": "Send IPN using the credentials of",
	"ui_label_redirect_payment_method": "Redirect payment method to",
	"ui_label_comission": "Commission",
	"ui_label_comission_account": "Commission account",
	"ui_label_comission_rate": "Commission rate",
	"ui_label_fixed_fee_transaction": "Fixed fees per transaction",
	"ui_label_variable_fee_transaction": "Variable fees per transaction",
	"ui_label_associated_remittance": "Associated remittance",
	"ui_label_associated_remittance_account": "Associated remittance accounts",
	"ui_label_boleto": "Boleto Express",
	"ui_label_cartao_credito": "Credit Card",
	"ui_label_juros_cc": "Interest CC",
	"ui_label_min": "Min",
	"ui_label_fee_a_vista": "One-off",
	"ui_label_fee_parcelado_2a6": "Installments 2 to 6",
	"ui_label_fee_parcelado_7a12": "Installments 7 to 12",
	"ui_label_fee_parcelado_7a24": "Installments 7 to 24",
	"ui_label_taxa_juros_cc": "Base Anticipation Fee",
	"ui_label_exemplo_juros": "Anticipation fee per installments",
	"ui_label_cartao_debito": "Debit Card",
	"ui_label_bank_transfer": "Bank transfer",
	"ui_label_refund": "Refund/Chargeback",
	"ui_label_cartoes_dc": "Credit/debit card",
	"ui_label_boleto_outros": "Boleto and others",
	"ui_label_invoice_information": "Invoice information",
	"ui_label_name_invoice": "Name on invoice",
	"ui_label_name_mcc_cod": "MCC code",
	"ui_label_alert_mcc_cod": "Risk MCC, report to compliance.",
	"ui_label_category": "Category",
	"ui_label_cnpj": "VAT/CNPJ",
	"ui_label_razao_social": "Razão social",
	"ui_label_pais": "Country",
	"ui_label_estado": "State",
	"ui_label_cidade": "City",
	"ui_label_cep": "Postal code",
	"ui_label_endereco": "Address",
	"ui_label_numero": "Number",
	"ui_label_complemento": "Additional",
	"ui_label_bairro": "Neighborhood",
	"ui_label_contrato_assinado": "Contract signed",
	"ui_label_last_kyc": "Last KYC update",
	"ui_label_account_contact_name": "Accounting contact name(s)",
	"ui_label_salutation_email": "Salutation for e-mail",
	"ui_label_account_contact_email": "Accounting contact e-mail(s)",
	"ui_label_bank_account": "Bank account (invoice footer)",
	"ui_label_email": "E-mail",
	"ui_label_receive_notification_update": "Receive notifications for updates on services",
	"ui_label_receive_notification_chargeback": "Receive notifications for chargebacks and rejected refunds",
	"ui_label_notification": "Notification",
	"ui_cf_password": "The new password and confirmation not match.",
	"ui_label_gateway_zero_auth": "Zero Auth",

	"ui_label_invoice_bank": "Bank",
	"ui_label_invoice_branch": "Branch",
	"ui_label_invoice_account": "Account",
	"ui_label_invoice_taxid": "TaxId",
	"ui_label_invoice_favorecido": "Favored",
	"ui_label_invoice_beneficiary": "Beneficiary",
	"ui_label_invoice_bank_name": "Bank name",
	"ui_label_invoice_branch_xb": "Branch",
	"ui_label_invoice_account_xb": "Account",
	"ui_label_invoice_bank_code": "Bank code",
	"ui_label_invoice_swift_code": "Swift code",
	"ui_label_invoice_aba_routing_number": "ABA routing number",
	"ui_label_invoice_iban_number": "IBAN number",
	"ui_label_invoice_additional_detail": "Additional details (if any)",

	"fx_rate_assured_remittance": "Remittance",
	"fx_rate_assured_transaction": "Transaction paid in BRL",
	"fx_rate_assured_created": "Transaction submitted in USD/EUR",

	"ui_label_notification_update": "Updates",
	"ui_label_notification_chargeback": "Chargebacks and rejected refunds",

	"ui_label_boleto_email_service": "E-mail service",
	"ui_label_nro_remaining_email": "No. of remaining e-mail credits",
	"ui_label_subscription": "Subscription",
	"ui_label_auto_renew": "Auto-renew",
	"ui_label_nro_remaining_sms": "No. of remaining SMS credits",
	"ui_label_boleto_sms_service": "SMS service",
	"ui_label_password_recovery": "Password recovery",
	"ui_label_configuration": "Configuration",
	"ui_label_answer": "Answer",
	"ui_label_security_question": "Security question",
	"ui_label_current_password": "Current password",
	"ui_label_new_password": "New password",
	"ui_label_payment_link": "Payment Link",
	"ui_label_boleto_tab": "Boleto",
	"ui_label_logo_boleto": "Your logo",
	"ui_label_logo_boleto_placeholder": "No file chosen",
	"ui_label_logo_boleto_table": "Logo",
	"ui_label_abreviacao": "Account manager abbreviation",
	"ui_label_account_manager": "Account Manager",
	"ui_label_shop_code": "Store code",
	"ui_label_resend_ipn_not_compliant": "Resend IPN not compliant",
	"ui_label_create_product_on_insert": "Create product on insert",
	"ui_label_create_product_on_insert_if_not_exists": "if not exists",
	"ui_label_distribution_center": "Distribution center",
	"ui_label_pod_routine": "POD routine",
	"ui_label_refundadicional": "Additional refund",
	"ui_label_send_customer_email": "Send customer email on IPN",
	"ui_label_manual": "Manual",
	"ui_label_default": "Default",
	"ui_label_return_refund_order": "Return of refund order",
	"ui_label_samsungpay": "Samsung Pay",
	"ui_label_refund_by": "Refund by",
	"ui_label_both": "Both",
	"ui_label_pix": "Pix",
	"ui_label_placeholders_service": "Placeholders",
	"ui_label_placeholders_store_name": "Store name",
	"ui_label_placeholders_store_contact": "Store contact",

	"ui_label_repasse_agendado": "Remittance Release Schedule ",
	"ui_label_days_added_default": "Days added by default",

	"accremitsch_payment_method": "Payment Method",
	"accremitsch_num_parcela": "Installments ",
	"accremitsch_num_dia": "Day(s) Added",

	"ui_label_enabled_payments": "Shopify",
	"ui_label_enabled_payments_desc": "Payment methods",
	"shopify_payments_pec": "PEC Flash",
	"shopify_payments_boleto": "Boleto Bancário",
	"shopify_payments_credit_card": "Credit Card",
	"shopify_payments_debit_card": "Debit Card",
	"shopify_payments_banco_brasil": "Banco do Brasil Comércio Eletrônico",
	"shopify_payments_bradesco": "Bradesco Comércio Eletrônico",
	"shopify_payments_banrisul": "Banricompras",
	"shopify_payments_itau": "Itaú Shopline",
	"shopify_payments_paypal": "PayPal",
	"shopify_payments_pix": "Pix",

	"shopify_fields_style": "Style",
	"shopify_fields_logo": "Logo",
	"shopify_fields_contact_channel": "Contact channel",
	"shopify_fields_transparent_checkout": "Transparent checkout",
	"shopify_fields_partial_status_fulfillment": "Partial status fulfillment",
	"shopify_fields_concatened_product_sku": "Concatenated product SKU",
	"shopify_fields_update_checkout_note": "Update checkout note",
	"shopify_fields_multiple_payments": "Allow payment with 2 methods",
	"shopify_fields_multiple_payments_combination": "Multiple payments combination", 
	"shopify_fields_card_to_card": "Card + Card",
	"shopify_fields_card_to_pix": "Card + Pix",
	"shopify_fields_pix_order_pending": "Pix order pending",
	"shopify_fields_boleto_order_pending": "Boleto order pending",
	"shopify_fields_only_update_order": "Only update order",
	"shopify_fields_get_company_name": "Get company name",
	"shopify_fields_format_address_tiny": "Format address tiny",
	"shopify_fields_save_original_attributes": "Save original attributes",

	"shopify_fields_checkout_version": "Checkout version",
	"shopify_fields_merchant_url": "Merchant's URL",
	"shopify_fields_verify_cep": "Verify CEP",
	"shopify_fields_cpfcnpj": "CPF/CNPJ on company",
	"shopify_fields_phone_mask": "Phone mask",
	"shopify_fields_activate_nupay_message": "Activate NuPay message",
	"shopify_fields_enable_message_nupay": "You can choose to pay using your account balance, credit, or NuPay’s additional limit in up to 36 installments.",
	"shopify_fields_disabled_message_nupay": "You will be redirected to a payment page.",
	"shopify_fields_company_name": "Company name field",
	"shopify_fields_auto_recurring": "Auto recurring",
	"shopify_fields_force_fallback": "Force fallback",
	"shopify_fields_additional_attributes": "Additional attributes",
	"shopify_options_disabled": "Disabled",
	"shopify_options_enabled": "Enabled",
	"shopify_options_enabled_with_attributes": "Enabled with additional attributes",
	"shopify_options_enabled_cpfcnpj": "Enabled CPF/CNPJ",
	"shopify_options_enabled_cpf": "Enabled CPF only",
	"shopify_options_enabled_cnpj": "Enabled CNPJ only",
	"shopify_options_checkout_v2": "Version 2",
	"shopify_options_checkout_v3": "Version 3 (recommended)",
	"shopify_options_creditcard_brand": "Credit card brand",
	"shopify_options_creditcard_installments": "Credit card installments",
	"shopify_options_boleto_url": "Boleto URL",
	"shopify_options_inscription": "State inscription",
	"shopify_tooltip_merchant_url": "The URL must be informed in the format \"store.myshopify.com\".",
	"shopify_tooltip_note_attributes": "Attributes that will be added to the order's note_attributes field.",
	"shopify_pagstream_settings": "PagStream settings",
	"shopify_general_settings": "General settings",
	"shopify_general_settings_internal": "General settings - internal",
	"shopify_frequency_radio_button_color": "Recurrence button color:",
	"shopify_frequency_select_button_color": "Frequency selector color:",
	"shopify_frequency_select_font_color": "Frequency selector font color:",
	"shopify_frequency_select_radius": "Frequency selector round:",
	"shopify_frequency_select_border": "Frequency selector border:",
	"shopify_frequency_select_border_color": "Border color:",
	"shopify_pagstream_recurrence_text": "Recurrence text:",
	"shopify_pagstream_frequency_text": "Frequency text:",
	"shopify_pagstream_frequency_empty": "Select a frequency and fill the visualization text",
	"shopify_pagstream_frequency_registered": "Frequency already registered",
	"shopify_pagstream_first_option_texts": "First option texts",
	"shopify_pagstream_option_label_text": "Label text:",
	"shopify_pagstream_second_option_texts": "Second option texts",
	"shopify_pagstream_warning_text": "Warning text:",
	"shopify_pagstream_general_styles": "General styles",
	"shopify_pagstream_selected_option_styles": "Selected option styles",
	"shopify_pagstream_option_border_color": "Options border color:",
	"shopify_pagstream_option_font_color": "Options font color:",
	"shopify_pagstream_radio_color": "Radio color:",
	"shopify_frequency_warning_text_color": "Warning text color:",
	"shopify_frequency_options_border_radius": "Options border radius:",
	"shopify_frequency_selected_option_bg": "Selected option background:",
	"shopify_frequency_selected_option_bg_not_selected": "Option background:",
	"shopify_frequency_selected_option_border_color": "Selected option border color:",
	"shopify_frequency_selected_option_font-color": "Selected option font color:",
	"shopify_tooltip_frequency_list": "Put your mouse over the frequency options and drag and drop the items to reorder the exibition.",
	"shopify_add_discount": "Add discount",
	"shopify_edit_discount": "Edit discount",
	"shopify_method_registered": "Payment method already has a registered discount",
	"shopify_method_not_registered": "You must fill all fields.",
	"shopify_pagstream_premium_subdomain": "PagStream Premium subdomain",
	"shopify_pagstream_premium_invalid_subdomain": "Insert a valid subdomain.",

	"shopify_fields_frequency_pagstream": "1-click subscription",
	"shopify_fields_all_products_pagstream": "Enable subscription for all products",
	"shopify_fields_frequency_code_pagstream": "Frequency code",
	"shopify_fields_text_frequency_pagstream": "Text for visualization",
	"shopify_fields_options_frequency_pagstream": "Frequency options added",
	"shopify_button_add_frequency": "Add Frequency",
	"shopify_button_update_frequency": "Update Frequency",
	"shopify_recurring_payment_options": "Subscription payment methods",
	"shopify_show_apple_pay": "Apple Pay for subscription",
	"shopify_one_installment_recurring": "One installment subscription",
	"shopify_cc_tokenization": "Tokenization",
	"shopify_apply_discount_into_checkout": "Apply discount into checkout (legacy app)",
	"shopify_recurring_methods_overwrite": "Subscription payment methods priority",
	"shopify_recurring_create_recurring_by_catalog": "Create recurring by catalog",
	"shopify_recurring_fixed_billing_date": "Fixed billing date",
	"shopify_recurring_catalog_base_day": "Catalog base day",
	"shopify_recurring_create_recurring_on_current_month": "Create recurring on current month",
	"shopify_recurring_recurring_installments": "Recurring installments",
	"shopify_recurring_min_value_installments_recurring": "Min value installments recurring",

	"shopify_recurring_methods_tooltip": "Enabling this option prioritizes subscription payment methods for mixed checkouts (subscriptions and regular purchases).",
	"shopify_discount_payment_method": "Discount by payment method",
	"shopify_discount_payment_config": "Payment method",
	"shopify_discount_payment_percentage": "Percentage",

	"ui_label_status_conta": "Account status",
	"status_conta_fechada": "Closed",
	"status_conta_online": "Live",
	"status_conta_bloqueada": "Blocked",

	"ui_label_preview": "Preview",
	"ui_logo_requirement": "Requirements: Use a PNG or SVG file with size limit of 170 x 35 pixels and transparent background.",
	"ui_error_upload_logo": "Error uploading the logo!",
	"ui_logo_removed": "Logo removed from your boletos!",
	"ui_logo_removed_direct": "Logo removed",
	"ui_error_remove_logo": "Error removing the logo!",

	"ui_account_sub": "Settings",
	"ui_email_title": "E-mail/SMS",
	"ui_config_title": "Admin Settings",
	"ui_customer_area_config_title": "Subscriber Portal",
	"ui_fee_title": "Account Fees",
	"ui_user_config_title": "Profile",
	"ui_user_list_title": "User List",
	"ui_blocklist_pix_roaming_title": "Blocklist Pix for international travelers",
	"ui_obt": "Online Banking Transfer",

	"ui_tooltip_pass_recovery": "Update your security question and answer, that you will need for resetting your password. The security question and answer must be at least 8 characters long.",
	"ui_placeholder_new_pass": "Input your new password if you want to change it",
	"ui_label_confirm_new_password": "Confirm new password",
	"ui_placeholder_security": "Input your new security question if you want to change it",
	"ui_placeholder_answer": "Inform your answer if you are changing your security question",

	"ui_alert_vencpec_limit": "The number of days for a PEC Flash to expire must be between 0 to 5",
	"ui_alert_freq_curremit_q": "You can't select \"Every Other Week\" as frequency and 'EUR' or 'USD' as currency remittance.",
	"ui_alert_freq_curremit_z": "You can't select \"Twice Month\" as frequency and 'BRL' as currency remittance.",

	"ui_erro_maxlength": "The field {fieldName} exceeded the maximum length",
	"ui_erro_minlength": "The field {fieldName} does not attend the minimum length",
	"ui_erro_empty": "The field {fieldName} must be filled",
	"ui_erro_invalid_postal_code": "Invalid Postal Code",
	"ui_erro_invalid_cnpj": "Invalid VAT/CNPJ",
	"ui_erro_invalid_branch": "Invalid branch",
	"ui_erro_invalid_account": "Invalid account",
	"ui_erro_invalid_taxid": "Invalid taxId",
	"ui_erro_invalid_phone_number": "The {fieldName} field must be a valid phone number",

	"ui_label_fee_installment_shopify": "Add interest to each installment",
	"ui_label_installment_fee_shopify_installments": "Min. number of installments to add interest to the amount",
	"ui_label_type_of_fee_shopify": "Interest fee to be added",
	"ui_label_type_of_fee_shopify_automatic": "Automatically calculated",
	"ui_label_type_of_fee_shopify_manual": "Manually defined",
	"ui_for_shopify": "For Shopify only",
	"ui_for_shopify_iframe": "For iFrame/plugin only",
	"ui_for_paylink_plugin": "For payment link/plugin only",
	"ui_help_fee_installment": "Example for a BRL 100 order:",

	"ui_alert_field": "Please complete all the fields.",
	"ui_alert_day_limit_999": "The automatic cancellation must be between 1 and 999 days.",

	"ui_super_config_title": "Configuration",
	"ui_label_create": "Create",
	"ui_label_save": "Save",
	"ui_label_save_future": "Update future charges",
	"ui_label_correios": "Correios",
	"ui_label_usuario_correios": "User Correios",
	"ui_label_senha_correios": "Password Correios",
	"ui_label_cartao_postagem_correios": "Postal Card Correios",
	"ui_label_valor_disponivel_despacho": "Balance at Correios",
	"ui_label_valor_alerta_despacho": "Balance Alert",
	"desc_alerta_despacho": "When 'Balance at Correios' is lower than 'Balance Alert' the system will create a support ticket.",

	"ui_label_autorec_day_anticipate_pl": "Days before billing date to create the Payment Link",
	"ui_label_autorec_day_anticipate_pl_desc": "Define how many days the Payment Link should be created before the billing date.",
	"ui_label_auto_recurring_multiple": "Create a subscription for",
	"ui_label_auto_recurring_multiple_opcao1": "Only the first rule that matches",
	"ui_label_auto_recurring_multiple_opcao2": "Each rule that matches",
	"ui_label_auto_recurring_multiple_desc": "If the product match to more then one rule, it will create more subscriptions.",
	"ui_label_auto_recurring_days_to_reminder": "Number of days a payment reminder is sent prior the billing date",
	"ui_label_autorecurring_auto_update": "Override all future charges",
	"ui_label_pagstream_multiple_card": "Allow charge every client's card by taxid",
	"ui_label_pagstream_allow_overdue": "Allow recurrences with late payments",
	"ui_label_pagstream_max_overdue": "Maximum number of late payments allowed",

	"ui_create_konduto_account": "Create Konduto Account",
	"ui_valida_create_konduto": "There's a pending update. Please save the changes before creating the Konduto account.",

	"ui_label_marketplace": 'Marketplace',
	"ui_label_seller": 'Seller',
	"marketplace": 'Marketplace',
	"master": 'Master',
	"ui_label_merchant": "Merchant",
	"ui_label_percentual": "Split",
	"split_value_invalid": "Invalid split value.",
	"ui_label_revenue_group": "Revenue Group",

	"ui_label_markup": "Markup",
	"ui_label_markup_nota_fiscal": "Nota Fiscal",
	"markup_merchant": "Markup Merchant",
	"ui_label_markup_fix": "Markup Fix",
	"markup_notafiscal_merchant_alert": "When the option 'Nota Fiscal' is set to 'Yes', you need to set the 'Markup Merchant'.",

	"label_cc_authentication": "Credit Card Authentication",
	"label_dc_authentication": "Debit Card Authentication",
	"label_cc_action_on_auth_fail": "Action when do not authenticate",
	"label_dc_action_on_auth_fail": "Action when do not authenticate",
	"label_addtoken_available": "addToken",
	"return_error":	"Return error",
	"proceed_to_authorization":	"Proceed to authorization",

	"sr_title": "Settlement Reports",
	"sr_tab_transfer": "Remittance",
	"sr_tab_sales": "Sales",
	"sr_tab_settlement": "Settlement",
	"sr_tab_transfer_title": "Remittance Reports",
	"sr_tab_sales_title": "Sales Reports",

	"sr_previsao": "Display Preliminary Amounts",
	"sr_update_reserve_amount": "Update reserve amount",
	"sr_inform_new_reserve": "Please inform the new amount for the reserve value",
	"sr_update_processed_amount": "Update processed amount",
	"sr_inform_new_processed": "Please inform the new amount for the processed value",
	"sr_date": "Date",

	"sr_report_date": "Report Date",
	"sr_sales": "Sales",
	"sr_amount_paid": "Amount Paid",
	"sr_amount_gross": "Gross Amount",
	"sr_fee": "Fees",
	"sr_refund": "Refunds",
	"sr_discounts": "Discounts",
	"sr_chargeback": "Chargebacks",
	"sr_amount_net": "Net Amount",
	"sr_remittance": "Remittance",
	"sr_reserve": "Reserve",
	"sr_transfer": "Remittance",
	"sr_transfer_date": "Remittance Date",
	"sr_transfer_sales_net": "Net Sales",
	"sr_previous_reserve": "Prev. Reserve",
	"sr_transfer_discounts": "Discounts",
	"sr_processed": "Processed",
	"sr_debits": "Debits",
	"sr_simulate": "Simulate",

	"sr_report": "Report",
	"sr_payout": "Payout",
	"sr_invoice": "Invoice",
	"sr_transaction": "Transaction",
	"sr_transactions": "Transactions",
	"sr_creditdebit": "Credit/Debit",
	"sr_amount_last_reserve": "Reserve already disbursed",
	"sr_amount_reserve_retained": "Current retained reserve",
	"sr_estimated": "Estimate based on transactions until ",
	"sr_preliminary": " (preliminary amounts).",
	"sr_results": "Results",
	"sr_show_future_values": "Display Preliminary Amounts",
	"sr_download": "Download",
	"sr_estimate_until": "Estimate until ",
	"sr_rs": " (R$)",
	"sr_usd": " (USD)",
	"sr_eur": " (EUR)",
	"sr_brl": " (BRL)",

	"sr_tooltip_report_date": "Report Date",
	"sr_tooltip_transaction": "Sales",
	"sr_tooltip_amount_paid": "Amount Paid",
	"sr_tooltip_amount_gross": "Gross Amount",
	"sr_tooltip_fee": "Fee",
	"sr_tooltip_creditdebit": "Credit/Debit",
	"sr_tooltip_refund": "Refund",
	"sr_tooltip_chargeback": "Chargeback",
	"sr_tooltip_amount_net": "Amount net",
	"sr_tooltip_remittance": "Remittance",
	"sr_tooltip_reserve": "Reserve",
	"sr_tooltip_processed": "Processed",
	"sr_tooltip_transfer_date": "Remittance Date",
	"sr_tooltip_transfer": "Remittance",
	"sr_tooltip_download": "Download",

	"sr_modal_information_title_30_days": "30 days",
	"sr_modal_information_title_180_days": "180 days",
	"sr_modal_information_how_calculation": "How the calculation is done",
	"sr_modal_information_content_A": "The total sum of payments of the last thirty (30) days.",
	"sr_modal_information_content_B": "The monthly average of payments in the last one hundred and eighty (180) days, including only the days with payments.",
	"sr_modal_information_content_C": "The total sum of payments in the last one hundred and eighty (180) days, in case there are less than thirty (30) days with payments in the period of one hundred and eighty (180) days.",
	"sr_modal_information_observation_C": "* Applies only when there are less than 30 days of sales in the last 180 days.",

	"sr_modal_formula_total_money_30_days": "R$ Total (30 days)",
	"sr_modal_formula_total_money_180_days": "R$ Total (180 days)",
	"sr_modal_information_percent_reserve": "% reserve",
	"sr_modal_information_days_with_sales": "No. of days with sales",

	"sr_send_to_pbf_title": "Data sent to Pre Repasse",
	"sr_send_to_pbf_date": "Payment Date",
	"sr_send_to_pbf_merchant": "Merchant",
	"sr_send_to_pbf_value": "Value",
	"sr_send_to_pbf_tax": "Tax",
	"sr_send_to_pbf_debit": "Debit",
	"sr_all_payments_total": "All Payments Total",

	"dr_title": "Sales Reports",
	"dr_boleto_express": "Boleto Express",
	"dr_boleto_flash": "Boleto Flash",
	"dr_credit_card_details": "Credit Cards Details",

	"dr_apple_pay_details": "Apple Pay Details",
	"dr_google_pay_details": "Google Pay Details",
	"dr_samsung_pay_details": "Samsung Pay Details",

	"dr_payment_method": "Payment Method",
	"dr_tipo": "Tipo",
	"dr_qty_total": "Qty Total",
	"dr_preauth_request": "Pre-Auth Requests",
	"dr_preauth_successful": "Pre-Auth Successful",
	"dr_capture_requests": "Capture Requests",
	"dr_completed_successful": "Completed Successful",
	"dr_conversion_rate": "Conversion Rate",
	"dr_success_rate": "Success Rate",
	"dr_revenue": "Revenue",
	"dr_refund": "Refunds",
	"dr_chargeback": "Chargebacks",
	"dr_fee": "Fees",
	"dr_net_total": "Net Total",
	"dr_chargeback_amount_paid": "Chargeback Ratio - Credit Cards - Based on the amount paid / submission month",
	"dr_chargeback_submission_month": "Chargeback Ratio - Credit Cards - Based on the number of transactions / submission month",
	"dr_chargeback_chargeback_month": "Chargeback Ratio - Credit Cards - Based on the number of transactions / chargeback month",
	"dr_select": "Select",
	"dr_day": "Day",
	"dr_month": "Month",
	"dr_period": "Period",
	"dr_conversion_rate_info": "Transactions successfully completed (not including pre-authorized ones).",
	"dr_success_rate_info": "Transactions successfully approved.",
	"dr_col_compress_title": "Pre-auth data",
	"dr_modal_chargeback_legend_critical_rate": "Critical chargeback rate",
	"dr_modal_chargeback_legend_high_rate": "High chargeback rate",

	"cr_title": "Commission Reports",
	"cr_payment_method": "Payment Method",
	"cr_total_fee": "Total Fees (w/o spread)",
	"cr_commissionable_fee": "Commissionable Fee",
	"cr_commission_rate": "Commission Rate",
	"cr_commission": "Commission",

	"gr_title": "Graphic Reports",
	"gr_merchant": "Merchant",
	"gr_type": "Type",
	"gr_stats": "Stats",
	"gr_details": "Details",
	"gr_filters": "Filters",
	"gr_amount_paid": "Amount Paid",
	"gr_payment_rejected": "Payment Rejected",
	"gr_chargebacks": "Chargebacks",
	"gr_payment_failed": "Payment Failed",
	"gr_refunds": "Refunds",
	"gr_pagbrasil_dc": "PagBrasil Debit/Credit",
	"gr_gateway": "Gateway",
	"gr_measures": "Measures",
	"gr_value": "Value (BRL)",
	"gr_quantity": "Quantity",
	"gr_fee": "Fee (BRL)",
	"gr_mes_atual": "Current Month",

	"ar_measures": "Measures",
	"ar_percentage": "Percentage",
	"ar_empty_chart": "No data.",
	"ar_value": "Value (BRL)",
	"ar_quantity": "Quantity",
	"ar_rec_new": "New subscriptions",
	"ar_rec_renewed": "Renewals processed",
	"ar_rec_pending": "Pending subscriptions",
	"ar_rec_canceled": "Cancelled subscriptions",
	"ar_active": "Actives",
	"ar_pending": "Pending",
	"ar_pending_first_payment": "Waiting for first payment",
	"ar_overdue": "Overdues",
	"ar_inactive": "Inactives",
	"ar_expired": "Expired",
	"ar_paused": "Paused",
	"ar_attempts": "Attempts",
	"ar_conversions": "Conversions",
	"ar_generated": "Generated",
	"ar_converted": "Converted",
	"ar_not_converted": "Not converted",
	"ar_predict_new": "New subscriptions",
	"ar_predict_renew": "Renewals processed",
	"ar_predict_predicted": "Renewals forecast",
	"ar_predict_cancelled": "Cancelled subscriptions",
	"ar_predict_expired": "Expired subscriptions",
	"ar_predict_paused": "Paused subscriptions",
	"ar_cancellation_lack_of_necessity_reason": "I no longer wish to receive the product/service",
	"ar_cancellation_low_satisfaction_reason": "I am not satisfied with the product/service",
	"ar_cancellation_regret_reason": "I regret the purchase",
	"ar_cancellation_another_reason": "Another reason",
	"ar_cancellation_by_system": "By system",
	"ar_cancellation_by_user": "By dashboard user",
	"ar_chart_period": "Events by date",
	"ar_chart_cancellation": "Cancellations",
	"ar_chart_pl_conversion": "Payment link",
	"ar_chart_recharge": "Charge retries",
	"ar_chart_event": "Events",
	"ar_chart_conversion": "Recurrence charges",
	"ar_chart_subscriptions": "Subscriptions",
	"ar_chart_jan_abreviacao": "Jan",
	"ar_chart_fev_abreviacao": "Feb",
	"ar_chart_mar_abreviacao": "Mar",
	"ar_chart_abr_abreviacao": "Apr",
	"ar_chart_mai_abreviacao": "May",
	"ar_chart_jun_abreviacao": "Jun",
	"ar_chart_jul_abreviacao": "Jul",
	"ar_chart_ago_abreviacao": "Aug",
	"ar_chart_set_abreviacao": "Sep",
	"ar_chart_out_abreviacao": "Oct",
	"ar_chart_nov_abreviacao": "Nov",
	"ar_chart_dez_abreviacao": "Dec",
	"ar_total": "Total",
	"ar_subscriber": "Subscriber",
	"ar_resume": "Resume",
	"ar_prediction": "Previsão próximos dias Traduzir",
	"ar_30_days": "30 days",
	"ar_12_months": "12 months",
	"ar_empty": "No information available to display.",
	"ar_invalid_period": "Invalid date. The minimum date range is {days} days.",
	"ar_all": "All",

	"resource_title": "Resources",

	"overview_online_acc": "Live Account",
	"overview_testing_acc": "Testing Account",
	"overview_closed_acc": "Closed Account",
	"overview_testing_closed_acc": "Closed Testing Account",
	"overview_low_touch": "Low touch",
	"overview_middle_touch": "Middle touch",
	"overview_high_touch": "High touch",
	"overview_top_tier": "Top tier",
	"overview_pb_eleva": "PB Eleva",
	"overview_none_touch": "Others",
	"search_tipo_order": "Order number",
	"search_tipo_internal_number": "Internal number",
	"search_tipo_email": "E-mail",
	"search_tipo_taxid": "TaxId",
	"submit": "Submit",
	"send_pbf": "Send to PBF",
	"save": "Save",
	"clone": "Clone",
	"execute": "Execute",
	"update": "Update",
	"close": "Close",
	"remove": "Remove",
	"send": "Send",
	"cancel": "Cancel",
	"pause": "Pause",
	"activate": "Activate",

	"pl_title": "Payment Link",
	"pl_search_title": "Search Payment Link",
	"pl_order": "Order",
	"pl_product_name": "Product name",
	"pl_customer_name": "Name",
	"pl_customer_taxid": "Taxid",
	"pl_customer_email": "E-mail",
	"pl_customer_phone": "Phone",
	"pl_address_street": "Address street",
	"pl_address_number": "Address number",
	"pl_address_number_complement": "Address number complement",
	"pl_address_neighborhood": "Address neighborhood",
	"pl_address_zip": "Address zip",
	"pl_address_city": "Address city",
	"pl_address_state": "Address state",
	"pl_amount": "Amount",
	"pl_amount_brl": "Amount (BRL)",
	"pl_fx_amount": "Amount ({0})",
	"pl_favorecido": "Customer list",
	"pl_payment_option": "Payment methods",
	"pl_url_retorno": "Return URL",
	"pl_url_parametro": "Extra parameters",
	"pl_btn_create": "Create",
	"pl_copy": "Copy",
	"pl_click_to_copy_link": "Click to copy link",
	"pl_generate_new_payment_link": "Generate new payment link",
	"pl_copy_to_your_clipboard": "Copy to your clipboard!!",

	"pl_invalid_field_order": "Invalid field (Order).",
	"pl_invalid_field_product_name": "Invalid field (Product name).",
	"pl_invalid_field_customer_name": "Invalid field (Customer name).",
	"pl_invalid_field_customer_taxid": "Invalid field (Customer taxid).",
	"pl_invalid_field_customer_email": "Invalid field (Customer e-mail).",
	"pl_invalid_field_customer_phone": "Invalid field (Customer phone).",
	"pl_invalid_field_address_street": "Invalid field (Address street).",
	"pl_invalid_field_address_zip": "Invalid field (Address zip).",
	"pl_invalid_field_address_city": "Invalid field (Address city).",
	"pl_invalid_field_address_state": "Invalid field (Address state).",
	"pl_invalid_field_amount_brl": "Invalid field (Amount BRL).",
	"pl_invalid_field_fx_amount": "Invalid field (Amount {0}).",
	"pl_invalid_field_discount_brl": "Invalid field (Discount R$).",
	"pl_invalid_field_payment_option": "Invalid field (Payment methods).",
	"pl_invalid_field_return_url": "Invalid field (Return URL).",
	"pl_invalid_field_payment_link_valid": "Invalid field (Payment link valid for).",
	"pl_invalid_field_boleto_expiration": "Invalid field (Boleto expiration)",
	"pl_invalid_field_pec_expiration": "Invalid field (PEC expiration)",
	"pl_invalid_field_pix_expiration": "Invalid field (Pix expiration)",
	"pl_failed_to_create": "Fail to create payment link.",
	"pl_please_provide_a_valid_email": "Please check the email provided",
	"pl_taxid_invalid": "Please check the CPF/CNPJ provided",
	"pl_duplicated_order": "Fail to create payment link - Duplicated Order",

	"pl_label_credit_card_auth": "Credit card action",
	"pl_label_credit_card_auth_0": "Authorize and debit",
	"pl_label_credit_card_auth_1": "Authorize only",
	"pl_label_soft_descriptor": "Soft descriptor",
	"pl_label_max_installments": "Installment",
	"pl_label_cc_installments": "Fix installment",
	"pl_product_list": "Product List",
	"pl_btn_select_products": "Product Catalog",
	"pl_label_selected_product": " product selected.",
	"pl_label_selected_products": " products selected.",
	"pl_label_no_product_selected": "No product selected.",
	"pl_label_remove_product": "Do you want to delete product: #product_name#?",
	"pl_label_quantity": "Quantity",
	"pl_label_discount": "Discount",
	"pl_label_details": "Details",
	"pl_label_customer_product_data": "Customer and product information",
	"pl_label_customer_address": "Customer address",
	"pl_label_advanced_settings": "Advanced settings",
	"pl_label_add_products_from_catalog": "Add products from catalog",
	"pl_label_request_address_data_customer": "Request the customer to enter their address",
	"pl_label_always_request_address_data_customer": "Always request address data from the customer",
	"pl_label_type_return_checkout": "Chose return format",
	"pl_info_override_max_installments": "Override max installment setting",
	"pl_info_product_name": "Fill the product name or create a list using the product catalog below",
	"pl_info_discount_range": "When the amount does not match any discount range, the discount defined in the Payment Discount will be applied",
	"pl_choose": "Choose",
	"pl_up_to": "Up to",
	"pl_interest_free": "interest free",
	"pl_with_interest": "with interest",
	"pl_currency_x_brl": "x BRL",
	"pl_hide_cc": "Hide credit card option:",

	"favorecido_title": "Customer List",
	"favorecido_product_name": "Product name",
	"favorecido_customer_name": "Customer name",
	"favorecido_customer_taxid": "Customer taxid",
	"favorecido_customer_email": "Customer e-mail",
	"favorecido_customer_phone": "Customer phone",
	"favorecido_address_street": "Address street",
	"favorecido_address_number": "Address number",
	"favorecido_address_complement": "Address number complement",
	"favorecido_address_neighborhood": "Address neighborhood",
	"favorecido_address_zip": "Address zip",
	"favorecido_address_city": "Address city",
	"favorecido_address_state": "Address state",

	"favorecido_msg_added": "Customer added successful.",
	"favorecido_msg_updated": "Customer updated successful.",
	"favorecido_msg_deleted": "Customer deleted successful.",
	"favorecido_msg_valid_taxid": "Invalid field (Tax ID).",
	"favorecido_msg_fields_required": "Required field is missing.",

	"fee_report": "Fee Report",

	"consolidate_stats": "Refresh",
	"consolidated_by_month": "Consolidated by Month",
	"cons_rep_total_pending_amt": "Total Pending Amount",
	"cons_rep_total_pending_bluestream": "Total Pending to Remit to Bluestream",
	"cons_rep_total_pending_pagsmart": "Total Pending to Remit to PagSmart",
	"cons_rep_date": "Date",
	"cons_rep_amount_paid": "Amount Paid",
	"cons_rep_fees_pb": "Fees (PB)",
	"cons_rep_fees_bs": "Fees (BS/PS)",
	"cons_rep_fees_total": "Fees (total)",
	"cons_rep_refund": "Refund",
	"cons_rep_chargeback": "Chargeback",
	"cons_rep_net_amt_est": "Net Amount EUR/USD",
	"cons_rep_net_amt": "Net Amount",

	"fsp_title": "Full Stats Payment",

	"fs_title": "Full Stats",
	"fs_credit_card": "Credit Card",
	"fs_payment_method": "Payment Method",
	"fs_qty_total": "Qty. Total",
	"fs_qty_successful": "Qty. Successful",
	"fs_perc_success": "Success Rate",
	"fs_revenue": "Revenue",
	"fs_tran_revenue": "Transaction Rev.",
	"fs_refund": "Refund",
	"fs_chargeback": "Chargeback",
	"fs_fee": "Fee",
	"fs_our_cost": "Our Cost",
	"fs_gross_profit": "Gross Profit",
	"fs_spread": "Spread Rev.",
	"fs_brand": "Brand",
	"fs_parcela": "Parcela",
	"fs_min_remittance": "Min. remittance",
	"fs_total_pending_amt": "Total Pending Amount :  BRL",
	"fs_alert_pending_amt": "Hide Pending Amount Alert",
	"fs_month" : "Month",
	"fs_months": "Months",
	"fs_choose": "You need to choose something!",

	"fs_date": "Date",
	"fs_amount_paid": "Amount Paid",
	"fs_fees": "Fees",
	"fs_refunds": "Refunds",
	"fs_chargebacks": "Chargebacks",
	"fs_remittance": "Remittance",
	"fs_net_amt": "Net Amount",
	"fs_reserve": "Reserve",
	"fs_processed": "Processed",
	"fs_tipo": "Type",
	"fs_select_month": "Select the month.",

	"fs_filter_activated": "Activated",
	"fs_filter_deactivated": "Deactivated",

	"forecast_title": "Forecast",

	"fee_nupay_cc" : "NuPay - Credit Card (One off) Fee",
	"fee_nupay_ccp" : "NuPay - Credit Card (Installments 2 to 6) Fee",
	"fee_nupay_ccp24" : "NuPay - Credit Card (Installments 7 to 24) Fee",
	"fee_nupay_dc" : "NuPay - Debit Card Fee",

	"fee_nupay_cc_report" : "NuPay CC fee (One off)",
	"fee_nupay_ccp_report" : "NuPay CC fee (2 to 6)",
	"fee_nupay_ccp24_report" : "NuPay CC fee (7 to 24)",
	"fee_nupay_dc_report" : "NuPay DC fee",

	"fc_title": "Monthly Comparison",
	"fc_merchant": "Merchant",
	"fc_revenue_forecast": "Current month (forecast)",
	"fc_revenue_mes_01": "Last month",
	"fc_revenue_mes_02": "Penultimate month",
	"fc_percentual_mes_01": "Variation",
	"fc_percentual_mes_02": "Variation",
	"fc_last_update": "Last Update",
	"fc_user": "User",

	"statstime_title": "Alert Report",
	"st_paymethod": "Payment Method",
	"st_date": "Date",
	"st_export_csv": "Export to CSV",
	"st_status": "Status",
	"st_24hour": "+24 hours without successful transactions",
	"st_72hour": "+72 hours without successful transactions",

	"rr_title": "Reserve Report",

	"status_live": "Live",
	"status_test": "Test",
	"status_closed": "Closed",
	"status_only_total": "Totals Only",
	"status_all": "All",
	"status_all_pagstream": "All",

	"new_title": "News",
	"new_pick_month": "Pick a month",
	"new_data": "Date",
	"new_tipo": "Type",
	"new_titulo": "Title",
	"new_acoes": "Actions",
	"new_ativo": "Enable",
	"new_inativo": "Disable",
	"new_conteudo": "Content",
	"new_holiday": "Monthly Holiday List",
	"new_more": "more",
	"new_information": "Information",
	"new_alert": "Alert",
	"new_warning": "Warning",
	"new_message": "Message",

	"hol_data": "Data",
	"hol_ativo": "Enable",
	"hol_inativo": "Disable",
	"hol_descricao": "Description",
	"hol_acoes": "Actions",
	"hol_title": "Holiday",
	"hol_bank": "Bank Holiday",

	"stdia_title": "Total Today",
	"stdia_merchant": "Merchant",
	"stdia_qty_total": "Qty. Total",
	"stdia_qty_successful": "Qty. Successful",
	"stdia_perc_success": "Success Rate",
	"stdia_revenue": "Revenue",
	"stdia_refund": "Refund",
	"stdia_chargeback": "Chargeback",
	"stdia_fee": "Fee",
	"stdia_our_cost": "Our Cost",
	"stdia_gross_profit": "Gross Profit",
	"stdia_spread": "Spread",

	"nf_title": "Nota Fiscal",
	"nf_title_markup": "Nota Fiscal Markup",
	"modal_gerar_nota": "Gerar Nota Fiscal",

	"pagshield_title": "PagShield",
	"pagshield_activate": "Activate PagShield:",
	"pagshield_by_activate": "By activating the PagShield fraud prevention service, you declare that you are authorized by your company to do so and that you understand and agree with the following terms and conditions.",
	"pagshield_terms": "Terms and conditions:",
	"pagshield_msg1": "PagShield uses self-learning buying behavior analysis technology, which helps to identify potential credit card fraud. To set up this service, the following steps must be carried out: acceptance of the terms and conditions of PagShield's service, configuration of the service below, addition of parameters to your existing API or iFrame integration and the addition of a JavaScript snippet to all webpages.",
	"pagshield_msg2": "Once activated and configured, any credit card transaction attempt with a payment amount equal or higher than the one defined below will be analyzed and a risk score provided via API. ",
	"pagshield_msg3": "PagBrasil charges a fee of BRL",
	"pagshield_msg4": "per analyzed transaction. Setup and configuration is free and you can request deactivation of the service at any time.",
	"pagshield_msg5": "The service is available instantly after activation and configuration.",
	"pagshield_please_email": "Please e-mail",
	"pagshield_msg6": "with any questions.",
	"pagshield_msg7": "Please check to confirm you have read and accept the above terms in order to activate PagShield.",
	"pagshield_msg8": "Anti-fraud service ID:",
	"pagshield_msg9": "For more information on how to change your ID please contact",
	"pagshield_payment_amount": "Minimum Amount for PagShield Analysis",
	"pagshield_msg10": "Process transactions with PagShield fraud prevention only when payment amount >= BRL",
	"pagshield_msg11": "Move the slider below to adjust the score:",
	"pagshield_recomendation": "Recommendation:",
	"pagshield_msg12": "Rule: SCORE >= 0 and SCORE <=",
	"pagshield_msg13": "Process order right away",
	"pagshield_msg14": "Rule: SCORE > ",
	"pagshield_msg15": "and SCORE <",
	"pagshield_msg16": "Pre-authorize for manual fraud check",
	"pagshield_msg17": "The pre-authorization (pre-auth) action allows online merchants to first reserve an amount on the payee's credit card, before performing additional anti-fraud checks and capturing the amount. Manual fraud checks need to be performed by the merchant. Transactions that pass the manual check can be captured via API or by clicking on 'Capture' after accessing an order at tab 'Search Order'. Transactions need to be captured no later than 14 days after which the pre-authorization expires.",
	"pagshield_msg18": "and SCORE <= 100",
	"pagshield_decline": "Decline",
	"pagshield_msg19": "Never process right away but pre-authorize for manual fraud check when this minimum amount is reached:",
	"pagshield_msg20": "The pre-authorization (pre-auth) action allows online merchants to first reserve an amount on the payee's credit card, before performing additional anti-fraud checks and capturing the amount. Manual fraud checks need to be performed by the merchant. Transactions that pass the manual check can be captured via API or by clicking on 'Capture' after accessing an order at tab 'Search Order'. Transactions need to be captured no later than 14 days after which the pre-authorization expires.",
	"pagshield_msg21": "IMPORTANT: Orders with a red fraud score will still be declined.",
	"pagshield_msg22": "In case of an error while obtaining the fraud score, take the following action:",
	"pagshield_msg23": "Process order right away",
	"pagshield_msg24": "Pre-authorize for manual fraud check",
	"pagshield_msg25": "The pre-authorization (pre-auth) action allows online merchants to first reserve an amount on the payee's credit card, before performing additional anti-fraud checks and capturing the amount. Manual fraud checks need to be performed by the merchant. Transactions that pass the manual check can be captured via API or by clicking on 'Capture' after accessing an order at tab 'Search Order'. Transactions need to be captured no later than 14 days after which the pre-authorization expires.",
	"pagshield_msg26": "Send an e-mail notification when a manual fraud check is required:",
	"pagshield_msg27": "Rule: SCORE >= ",
	"pagshield_email": "E-mail:",
	"pagshield_msg28": "E-mail of the person responsible to perform additional anti-fraud checks to decide if the transaction will be approved (captured) or not. Please separate different e-mail addresses by a comma.",
	"pagshield_msg29": "PagShield is PagBrasil's intelligent and state-of-the-art fraud prevention solution. It is specifically designed for Brazil and based on a unique technology with intelligent self-learning buying behavior analyses, which fights fraud in real-time at a low cost. It will help you to identify fraudulent transactions automatically and reduce false positives.",
	"pagshield_msg30": "The cost for the PagShield service is just BRL ",
	"pagshield_msg31": "per credit card transaction attempt. You may exclude small transaction amounts from the fraud check, so that these don't generate any additional costs for you at all.",
	"pagshield_msg32": "How to get started?",
	"pagshield_msg33": "1. Download our 'Merchant Guide PagShield Fraud Prevention' at the tab Resources.",
	"pagshield_msg34": "2. E-mail ",
	"pagshield_msg35": "to request activation of the PagShield fraud-prevention service.",
	"pagshield_msg36": "3. Once activated, you can configure PagShield easily at this tab with just a few clicks.",
	"pagshield_msg37": "Attention: Orders generated using payment links may also carry a risk of fraud. By disabling PagShield for these orders, you must be aware of the potential risk of chargeback.",
	"pagshield_msg38": "Disable PagShield for payment links:",
	"pagshield_sell_safely": "Sell safely!",
	"pagshield_alert_msg": "PagShield submitted successfully.",
	"pagshield_approve": "Approve",
	"pagshield_review": "Review",
	"pagshield_decline": "Decline",
	"pagshield_action": "Action",
	"pagshield_checkshdamt": "Setting an amount other than BRL 0.00 in this field means that all orders below this amount will not undergo any type of risk analysis, increasing the risk of fraudulent transactions being approved.",
	"pagshield_checkshdscr1": "All orders starting at score 30 are risky and have a higher chance of becoming chargebacks. We recommend being very careful with raising the green section to automatically approve these orders.",
	"pagshield_slider_history": "Change History",
	"pagshield_previus_score": "Previous Score",

	"payee_title": "Payees",
	"payee_id": "Id",
	"payee_cpfcnpj": "Tax ID",
	"payee_merchant": "Merchant",
	"payee_name": "Name",
	"payee_email": "E-mail",
	"payee_phone": "Phone",
	"payee_address": "Address",
	"payee_street": "Street",
	"payee_zip": "Zip",
	"payee_city": "City",
	"payee_state": "State",
	"payee_bank_detail": "Bank Details",
	"payee_bank": "Bank",
	"payee_branch": "Branch",
	"payee_account": "Account",
	"payee_account_type": "Account type",
	"payee_document_link": "Document link",
	"payee_description": "Description",
	"payee_status": "Status",
	"payee_acoes": "Actions",
	"payee_status_pending": "Pending",
	"payee_status_approved": "Approved",
	"payee_status_reject": "Rejected",
	"payee_justification": "Reason",
	"payee_document": "Document",
	"payee_checking": "Checking Account",
	"payee_savings": "Savings",
	"payee_generate_payout": "Send Payout",
	"payee_validate_payee": "Validate Payee",
	"payee_amount": "Amount",
	"payee_btn_validate": "Validate",
	"payee_btn_edit": "Edit",
	"payee_btn_delete": "Delete",
	"payee_btn_execute": "Send Payout",
	"payee_status_atualizado": "Status updated successfully.",
	"payee_checking": "Checking",
	"payee_saving": "Savings",

	"payout_settings_title": "Payout Settings",
	"payout_settings_ativo": "Payout",
	"payout_settings_tipo_transacao": "Transaction type",
	"payout_settings_ambas": "Both",
	"payout_settings_apenas_payee": "Only payee",
	"payout_settings_apenas_merchant": "Only merchant",
	"payout_settings_saldo": "Total balance",
	"payout_settings_saldo_minimo": "Total reserve",
	"payout_settings_saldo_minimo_tooltip": "This amount corresponds to the percentage of reserve applied to the total transacted in the Collection account according to the contract rules.",
	"payout_settings_saldo_percentual": "Reserve percentage",
	"payout_settings_saldo_liquido": "Available net balance",
	"payout_settings_saldo_liquido_tooltip": "Available balance for payout. Total balance - Total reserve.",
	"payout_settings_aprovacao_payee": "Review payee inclusion",
	"payout_settings_formato": "Response type",
	"payout_settings_alert_threshold": "Amount payout alert",
	"payout_settings_dia_adiamento": "Payout deferral",

	"payout_title": "Payout",
	"payout_id": "Id",
	"payout_detail": "Details",
	"payout_valor": "Amount",
	"payout_data_cadastro": "Date",
	"payout_data_pagamento": "Payout Date",
	"payout_type": "Type",
	"payout_status": "Status",
	"payout_acoes": "Actions",
	"payout_status_pending": "Pending",
	"payout_status_approved": "Completed",
	"payout_status_fail": "Failed",
	"payout_status_schedule": "Scheduled",
	"payout_payee": "Payee",
	"payout_merchant": "Merchant",
	"payout_current_limit": "Current limit for payouts",
	"payout_select_merchant": "Please select the recipient.",
	"payout_savings": "Savings",
	"payout_checking": "Checking",
	"payout_name": "Name",
	"payout_taxid": "Tax Id",
	"payout_description": "Description",
	"payout_data_processamento": "Process date",
	"payout_between_accounts": "Between PagBrasil accounts",

	"payout_fee_info1": "Payout to payee",
	"payout_fee_info2": "Payout to merchant account",
	"payout_fee_info3": "Payee approval or rejection",

	"payout_movement_title": "Pay-in/Payout",
	"payout_movement_id": "Id",
	"payout_movement_data_inclusao": "Date",
	"payout_movement_amount": "Amount",
	"payout_movement_description": "Description",
	"payout_movement_merchant_origin": "Origin merchant",
	"payout_movement_ordem_origin": "Origin order",
	"payout_movement_payout_id": "Payout Id",
	"payout_movement_order": "Order",

	"pg_title": "Permission Group",
	"pg_descricao": "Description",
	"pg_tipo": "Type",
	"pg_acoes": "Actions",

	"user_title": "User",
	"user_merchant_number": "Merchant",
	"user_username": "Username",
	"user_rep_format": "Date and decimal format",
	"user_tipo": "Type",
	"user_idgrupo_permissao": "Permission Group",
	"user_descricao": "Description",
	"user_acoes": "Action",
	"user_password": "Password",
	"user_tentativa": "Login Attempts",
	"user_email": "E-mail",
	"user_questao": "Question",
	"user_resposta": "Answer",
	"user_viewonly": "View Only",
	"user_restrict": "Restrict",
	"user_fullaccess": "Full Access",
	"user_superuser": "Super User",
	"user_login_mes": "Month Login",
	"user_status": "Status",
	"user_status_active": "Active",
	"user_status_blocked": "Blocked",
	"user_status_permanently_blocked": "Permanently blocked",
	"user_inclusao_sucesso": "Successful inclusion.",
	"user_alteracao_sucesso": "Successful update.",
	"user_block_user": "Block User",
	"user_reset_password": "Reset Password",
	"user_unblock_user": "Unlock User",
	"user_reset_double_factor": "Reset two-factor authentication",
	"user_minimum_fields": "Inform Username, E-mail, Type or Permission Group",
	"user_password_reset": "Password reset: ",
	"user_blocked": "User blocked",
	"user_unblocked": "User unblocked",
	"user_clean_two_factor": "Do you want to clear the two-factor authentication token?",
	"user_clean_two_factor_success": "Two-factor authentication cleared successfully.",
	"user_clone_success": "Clone successfully.",

	"pixconfig_id": "Id",
	"pixconfig_banco": "Bank",
	"pixconfig_prioridade": "Priority",
	"pixconfig_ativo": "Active",
	"pixconfig_info_pagador": "Payer Info",
	"pixconfig_fluxo_inativo": "Temporary Inactive",

	"perm_id": "Id",
	"perm_idgrupo_permissao": "Permission Group",
	"perm_sistema": "System",
	"perm_acoes": "Actions",
	"perm_title": "Permissions",
	"perm_insert": "Insert",
	"perm_update": "Update",
	"perm_delete": "Delete",
	"perm_select": "Select",

	"pc_title": "Field Permission",
	"pe_title": "Special Permission",
	"pm_title": "Permission Merchant",
	"pe_id": "Id",
	"pe_idgrupo_permissao": "Permission Group",
	"pe_merchant": "Merchant",
	"pe_operacao": "Operation",
	"pe_permitido": "Allowed",
	"pe_acoes": "Actions",
	"pe_search_on": "SearchOrder: Search On Gateway",
	"pe_update_via": "SearchOrder: Update on Cielo/Elavon",
	"pe_revert_refund": "SearchOrder: Revert Refund",
	"pe_refund": "SearchOrder: Refund",
	"pe_refund_by_bank": "SearchOrder: Refund by Bank Transfer",
	"pe_chargeback": "SearchOrder: Chargeback",
	"pe_show_return_url": "SearchOrder: Show 'Return URL'",
	"pe_show_cv_tid": "SearchOrder: Show 'CV' or 'TID'",
	"pe_show_intern_info": "SearchOrder: Show 'Internal information'",
	"pe_do_refund_closed": "SearchOrder: Do refund on closed account",
	"pe_show_reserve": "Reserve: Show 'Reserve'",
	"pe_do_reserve": "Settlement: Do 'Reserve'",
	"pe_do_processed": "Settlement: Do 'Processed'",
	"pe_reset_password": "User: Reset Password",
	"pe_lock_user": "User: Lock User",
	"pe_unlock_user": "User: Unlock User",
	"pe_status_boleto": "SearchOrder: Boleto Status",
	"pe_admin_order": "SearchOrder: Admin order",
	"pe_revisao_account": "Account: Revision",
	"pe_fullstats_refresh": "Stats: FullStats Refresh",
	"pe_fullstatspayment_refresh": "Stats: FullStatsPayment Refresh",
	"pe_payee_approve": "Payout: Payee Approval",
	"pe_payment_discount": "Products: Payment Link - Payment Discount",
	"pe_products_enabledpayments": "Products: Payment Methods",
	"pe_issuingbank_pix": "SearchOrder: Issuing Bank = Pix",
	"pe_sistema": "System",
	"pe_campo": "Field",
	"pe_insert": "Insert",
	"pe_select": "Select",
	"pe_destaque": "Highlight",
	"pe_toggle_insert": "Toggle Inserts",
	"pe_toggle_select": "Toggle Selects",
	"pe_toggle_highlight": "Toggle Highlights",
	"pe_pod_admin": "POD Report: Admin",
	"pe_add_new_order": "SearchOrder: Add New Order",
	"pe_cancel_order": "SearchOrder: Cancel Order",
	"pe_desativar_pagshield": "PagShield: Deactivate",
	"pe_extend_expiration": "SearchOrder: Extend expiration date",
	"pe_anticipation_approve": "Approve Anticipation",
	"pe_anticipation_reject": "Reject Anticipation",
	"pe_new_order_model_option_fee": "SearchOrder: Fee Option Order Template",
	"pe_new_order_model_option_payment": "SearchOrder: Payment Option Order Template",
	"pe_block_capture": "SearchOrder: Block order capture",
	"pe_revenue_group_list": "Account: Revenue group list",
	"pe_pagstream_reactivate_subscription": "Pagstream: Reactivate subscription",

	"refr_title": "Refund/Chargeback Report",
	"refr_refunds": "Refunds",
	"refr_chargebacks": "Chargebacks",
	"refr_payment_method": "Payment Method",
	"refr_qty_total": "Qty. Total",
	"refr_vlr_original": "Order Amount",
	"refr_refund": "Refund",
	"refr_fee": "Fee",

	"payment_pec": "PEC Flash",
	"payment_boleto": "Boleto Bancário",
	"payment_boleto_flash": "Boleto Flash",
	"payment_credit_card": "Credit Card",
	"payment_debit_card": "Debit Card",
	"payment_debit_flash": "Débito Flash",
	"payment_banco_brasil": "Banco do Brasil",
	"payment_pb_debit_credit": "PagBrasil debit/credit",
	"payment_bradesco": "Bradesco",
	"payment_banrisul": "Banrisul",
	"payment_obt": "Bank Transfer/Deposit",
	"payment_itau": "Itaú",
	"payment_paypal": "PayPal",
	"payment_nupay": "NuPay",
	"payment_pix": "Pix",
	"payment_boleto_express_flash": "Boleto Express/Flash",
	"payment_nupay": "NuPay",

	"payment_remittance_date": "Date",
	"payment_remittance_fx_amount": "FX Amount",

	"revenue_title": "Revenue Report",
	"revenue_boleto_fee": "Boleto Fee",
	"revenue_boleto_fix": "Boleto Fix",
	"revenue_boleto_min": "Boleto Min.",
	"revenue_flash_fee": "Boleto Flash Fee",
	"revenue_flash_fix": "Boleto Flash Fix",
	"revenue_cc_fee_a_vista": "CC Fee à vista",
	"revenue_cc_fee_2_6": "CC Fee de 2 a 6",
	"revenue_cc_fee_7_12": "CC Fee de 7 a 12",
	"revenue_cc_fix": "CC Fix",
	"revenue_dc_fee": "DC Fee",
	"revenue_dc_fix": "DC Fix",
	"revenue_pagbrasil_solution": "PagBrasil Solution",
	"revenue_pagbrasil_solution_gateway": "Gateway Solution",
	"revenue_pagbrasil_solution_intermediacao": "Intermediation Solution",
	"revenue_banricompras_fee": "Banricompras Fee",
	"revenue_banricompras_fix": "Banricompras Fix",
	"revenue_bradesco_fee": "Bradesco CE Fee",
	"revenue_bradesco_fix": "Bradesco CE Fix",
	"revenue_bb_fee": "BB Fee",
	"revenue_bb_fix": "BB Fix",
	"revenue_itau_fee": "ITAU Fee",
	"revenue_itau_fix": "ITAU Fix",
	"revenue_obt_fee": "Bank Transfer Fee",
	"revenue_obt_fix": "Bank Transfer Fix",
	"revenue_chargeback": "Chargeback",
	"revenue_refund_cartoes": "Refund Card",
	"revenue_refund_boleto": "Refund Boleto",
	"revenue_reserve_of": "Reserve of",
	"revenue_rate_cc": "Interest rate CC",
	"revenue_remittance_fee": "Remittance Fee",
	"revenue_remittance_minimum": "Minimum remittance",
	"revenue_pec_fee": "PEC Flash Fee",
	"revenue_pec_fix": "PEC Flash Fix",
	"revenue_pix_fee": "Pix Fee",
	"revenue_pix_fee_auto": "Pix Automático Fee",
	"revenue_pix_fix": "Pix Fix",
	"revenue_paypal": "PayPal",
	"revenue_average": "Average",
	"revenue_jan_mar": "January - March",
	"revenue_abr_jun": "April - June",
	"revenue_jul_set": "July - September",
	"revenue_out_dez": "October - December",
	"revenue_fee": "Fee",
	"filtrar_troca_faixa": "Filter range changes only",
	"trocar_todas_faixa": "Change all ranges",
	"faixa_atual": "Range active",
	"trocar_faixa": "Trocar faixa",
	"proxima_faixa": "Next Range",

	"freq_test_account": "Test Account",
	"freq_maintence_account": "Maintenance account",
	"freq_daily": "Daily",
	"freq_weekly": "Weekly",
	"freq_every_other_week": "Every other week",
	"freq_twice_month": "Twice a month",
	"freq_monthly_15": "Monthly on the 15th day",
	"freq_closed_account": "Closed account",
	"freq_closed_testing": "Closed testing account",
	"freq_no_settlement": "No settlement",

	"login_title": "Login",
	"login_username": "Username",
	"login_username_ph": "Enter your username",
	"login_password": "Password",
	"login_password_ph": "Enter your password",
	"login_password_tooltip": "Your password must be at least 8 characters long and must contain an uppercase and a lowercase letter, a number and a non-alphanumeric character.",
	"login_gtoken_ph": "Token",
	"login_first_login": "First login?",
	"login_first_login_message": "Leave it blank on your first login.",
	"login_validate_gtoken": "Validate Token",
	"login_new_password": "New Password",
	"login_confirm_password": "Confirm Password",
	"login_confirm_new_password": "Confirm New Password",
	"login_security_question": "Security Question",
	"login_answer": "Answer",
	"login_forgot_password": "Forgot password",
	"login_unlock_account": "Unlock account",
	"login_msg_invalid_username": "Invalid Username.",
	"login_msg_check_your_email": "Please check your e-mail for instructions on how to reset your password or unlock your account.",
	"login_msg_password_same": "The passwords are not the same.",
	"login_msg_inform_pass": "You need to inform your password.",
	"login_msg_inform_new_pass": "You need to inform your new password.",
	"login_msg_inform_question": "You need to inform your question.",
	"login_msg_inform_answer": "You need to inform your awnser.",
	"login_msg_password_updated": "Your password has been updated.",
	"login_msg_space_trim": "You must not use a space character at begin or end of your password.",
	"login_msg_space_trim_super": "Do not use a space character at begin or end of username or password.",
	"login_remember_this_computer": "Don't ask again for the token on this device",
	"login_first_access": "First access",
	"login_create_new_password": "Create new password",
	"login_back_to_login": "Back to login",
	"login_forgot_your_password": "Forgot your password?",
	"login_save_token_on_this_device": "Save token on this device.",
	"login_code": "Informe o código",
	"login_two_factor_authentication": "Enable two-factor authentication (required)",
	"login_text_one_part_one_authentication": "Download and install an authentication app on your phone.",
	"login_text_one_part_two_authentication": "We recommend the ",
	"login_or": "or",
	"login_microsoft_authenticator": "Microsoft Authenticator",
	"login_google_authenticator": "Google Authenticator",
	"login_duo_authenticator": "Duo",
	"login_text_two_authentication": "Open the chosen application and scan the QR code below:",
	"login_validate_token": "Validate token",
	"login_your_password_must_contain": "Your password must contain:",
	"login_8_characters": "8 characters",
	"login_lowercase": "Lowercase",
	"login_capital_letters": "Capital letters",
	"login_special_character": "Special character",
	"login_numbers": "Numbers",
	"login_recover_password": "Recover password",
	"login_we_send_a_code_to": "A recovery code has been sent to the email address associated with this account.",
	"login_check_inbox_or_spam": "Please check your inbox or spam folder.",
	"login_enter_code": "Enter the code:",
	"login_i_didnt_receive_the_email": "I didn't receive the email. ",
	"login_resend_code": "Resend the code.",
	"login_msg_invalid_access_code": "Invalid access code!",
	"login_create_password_and_access": "Create password and access",

	"login_msg_invalid_username_password": "Invalid Username/Password.",
	"login_msg_invalid_username_password_token": "Invalid Username/Password/Token.",
	"login_msg_all_fields_Are_required": "All fields are required!",
	"login_msg_same_password_confirmation": "Please enter the same password on new password and confirmation fields.",
	"login_msg_invalid_digits_password": "Your password must be at least 8 characters long and must contain an uppercase and a lowercase letter, a number and a non-alphanumeric character.",
	"login_msg_error_reset": "An error occured during your reset password.",
	"login_msg_username_locked": "Your username has been locked. Please click at 'Forgot password'.",
	"login_no_access": "Access denied. Contact your administrator.",

	"message_title_success": "Success",
	"message_title_warning": "Warning",
	"message_title_error": "Error",

	"pod_title": "Proof of Delivery",
	"pod_order": "Order",
	"pod_report": "Report",
	"pod_payment_date": "Payment Date",
	"pod_tracking_code": "Tracking Code",
	"pod_amount_paid": "Amount Paid",
	"pod_net_amount": "Net Amount",
	"pod_status": "Status",
	"pod_entrega": "Delivery",
	"pod_status_delivery": "Status delivery",
	"pod_pending": "Pending",
	"pod_invalid": "Invalid",
	"pod_empty": "Empty",
	"pod_not_found": "Not Found",
	"pod_valid": "Valid",
	"pod_processing": "Processing",
	"pod_import": "Import",
	"pod_import_file": "Upload File",
	"pod_file_requirement": "Must be a CSV file with 2 columns (order;tracking code), using ';' as the separator.",
	"pod_example_file": "Sample File",
	"pod_ret_inclusao_pod1": " item imported.",
	"pod_ret_inclusao_pod": " items imported.",
	"pod_export_limit": "Export limit exceeded (10000 rows). Please apply more filter.",
	"pod_data_submis": "Submission Date",
	"pod_acoes": "Actions",
	"pod_reprocessar": "Reprocess",
	"pod_marcar_reprocessado_sub": "This will change all items with status 'Not Found' to 'Pending' allowing them to be reprocessed. This will only affect items imported within 30 days.",
	"pod_reprocessado_sucesso": "Operation completed successfully.",
	"pod_find_17track": "Search at 17track",
	"pod_import_17track": "Import from 17track",
	"pod_17track_return": "17track return",
	"pod_set_all_valid": "Set all as valid",
	"pod_set_valid": "Set as valid",
	"pod_set_invalid": "Set as invalid",
	"pod_total_not_valid": "Total not valid",
	"pod_qtde": "Qty.",
	"pod_separator": "Separator",
	"pod_separator_track": "Tracking Code Separator",
	"pod_select_columns": "Please select the corresponding columns.",

	"pod_em_transito": "In transit",
	"pod_alerta": "Warning",
	"pod_entregue": "Delivered",
	"pod_indefinido": "Undefined",

	"pod_question_valid": "Do you want to set this item as valid?",
	"pod_question_valid_result": "Set as valid successfully.",
	"pod_question_invalid": "Do you want to set this item as invalid?",
	"pod_question_invalid_result": "Set as invalid successfully.",
	"pod_question_valid_all": "Do you want to set all selected items as valid?",

	"autorecset_title": "Rules",
	"autorecset_id": "ID",
	"autorecset_acoes": "Actions",
	"autorecset_product": "Product",
	"autorecset_product_info": "The product name must be equal or contain this text to trigger the creation of a subscription.",
	"autorecset_frequency": "Billing cycle",
	"autorecset_shipping_cycle": "Shipping cycle",
	"autorecset_status": "Status",
	"autorecset_limit": "Renewals limit",
	"autorecset_type": "Type",
	"autorecset_order": "Order",
	"autorecset_qtde_provisionamento_pre": "View",
	"autorecset_qtde_provisionamento_pos": "next charges",
	"autorecset_error_msg_empty": "Please complete the fields 'Product', 'Type', 'Billing cycle' and 'Status'.",
	"autorecset_sku_error_msg_empty": "Please complete the fields 'Product SKU', 'Billing cycle' and 'Status'.",
	"autorecset_error_duplicated": "This rule can't be created because it conflicts with an existing rule and would generate duplicated subscriptions. Please change the text to be searched for within the product name.",
	"autorecset_limit_warn": "Maximum subscription renewals (0 is unlimited).",
	"autorecset_amount": "Amount (BRL)",
	"autorecset_equal": "Equals",
	"autorecset_contains": "Contains",
	"autorecset_to": "to",
	"autorecset_editnotallowed": "It's not possible to edit a rule with linked subcription renewals. If necessary, please create a new rule.",
	"autorecset_amount_info": "Amount to charge for the subscription renewals (set as 0 to use the initial order amount).",
	"autorecset_error_delete": "This rule can't be deleted because it's linked to a subscription.",
	"autorecset_sku": "Product SKU",
	"autorecset_search": "Search for rules...",

	"autorec_config_error": "Error: PagStream requires recurring payments to be activated for this account.",

	"autorec_title": "Subscriptions",
	"autorec_charges": "Charges",
	"autorec_charge_errors": "Charge errors",
	"autorec_events": "Events",
	"autorec_id": "ID",
	"autorec_acoes": "Actions",
	"autorec_order_number": "Subscription",
	"autorec_order_number_rec": "Order",
	"autorec_empty": "-",
	"autorec_no_changes": "The subscription has not been updated.",
	"autorec_autorecset_id": "Rule",
	"autorec_product": "Product",
	"autorec_payment_date": "Payment date",
	"autorec_rule_id": "Rule ID",
	"autorec_product_matched": "Rule",
	"autorec_payment_method": "Method",
	"autorec_frequency": "Billing cycle",
	"autorec_status": "Status",
	"autorec_status_original": "Old status",
	"autorec_status_novo": "New status",
	"autorec_order_number_status": "Order status",
	"autorec_charge_status": "Charge status",
	"autorec_subscription_status": "Subscription status",
	"autorec_qtde_gerado": "Number of Renewals",
	"autorec_data_prox_cobranca": "Next billing date",
	"autorec_submission_date": "Submission date",
	"autorec_data_cobranca": "Billing date",
	"autorec_error_msg_empty_api": "Please complete the all required fields.",
	"autorec_error_empty_filter": "Please filter by next billing date, customer email or customer taxid to generate a report to be exported.",
	"autorec_error_invalid_filter": "Invalid date. The maximum date range is 120 days.",
	"autorec_item_error_msg_empty": "Please complete the fields 'Product' and 'Qty.'.",
	"autorec_data_nascimento": "Birth date",
	"autorec_data_cancelamento": "Cancellation date",
	"autorec_data_cancelamento_efetivo": "Effective cancellation date",
	"autorec_limit": "Limit",
	"autorec_default": "Default",
	"autorec_qtde_provisionamento_pre": "View",
	"autorec_qtde_provisionamento_pos": "next charges",
	"autorec_prev_saved": "Tokenized order",
	"autorec_pix_rec_id": "Pix Recurrence ID",
	"autorec_amount": "Amount (BRL)",
	"autorec_amount_total": "Total amount (BRL)",
	"autorec_amount_without": "Amount",
	"autorec_isentar": "Waive this billing",
	"autorec_pular": "Skip",
	"autorec_pular_confirm": "Are you sure you want to skip this charge?",
	"autorec_cancel_subscription": "Are you sure you want to cancel this subscription?",
	"autorec_pause_subscription": "Are you sure you want to pause this subscription?",
	"autorec_activate_subscription": "Are you sure you want to activate this subscription?",
	"autorec_reativar_confirm": "This charge has already been skipped. Are you sure you want to reactivate it?",
	"autorec_subscription_edit_data": "Edit subscription data",
	"autorec_credit_card_edit_data": "Edit credit card data",
	"autorec_customer_edit_data": "Edit customer data",
	"autorec_customer": "Customer",
	"autorec_customer_filter": "Name, taxid and e-mail",
	"autorec_customer_name": "Name",
	"autorec_customer_taxid": "Taxid",
	"autorec_customer_email": "E-mail",
	"autorec_customer_phone": "Phone",
	"autorec_address_street": "Street",
	"autorec_address_zip": "Zip",
	"autorec_address_city": "City",
	"autorec_address_state": "State",
	"autorec_cc_holder": "Holder",
	"autorec_cc_number": "Number",
	"autorec_cc_expiration": "Expiration",
	"autorec_cc_cvv": "CVV",
	"autorec_customer": "Customer",
	"autorec_cc": "Credit Card",
	"autorec_pix_automatico": "Automatic Pix",
	"autorec_payment_info": "Payment information",
	"autorec_subscription": "Subscription",
	"autorec_num_recorrencia": "Num. recurring",
	"autorec_desconto": "Discount (%)",
	"autorec_limite_max": "*Invalid percentage.",
	"autorec_produto": "Product",
	"autorec_quantidade": "Qty.",
	"autorec_lista_item": "Items list",
	"autorec_charge_tries": "Charge attempt",
	"autorec_dia_base": "Billing day of the month",
	"autorec_cycle_turnover_day": "Day of cycle turnover",
	"autorec_atualizar_provisionamento": "You will update all pending provisioning, defining dates, items e amounts.",
	"autorec_param_url": "Extra parameters",
	"autorec_url_return": "Return URL",
	"autorec_url_return_info": "Redirection URL when payment is completed using the link e-mailed to the customer.",
	"autorec_shop_code": "Store code",
	"autorec_installments": "Installments",
	"autorec_search_products": "Search for products...",
	"autorec_change_billing_cycle": "Change cycle",
	"autorec_change_billing_cycle_confirm": "Are you sure you want to change this subscription's cycle?",
	"autorec_reactivate": "Reactivate",
	"autorec_reactivate_subscription": "Reactivate subscription",
	"autorec_select_renewal_option": "Select the reactivation option:",
	"autorec_renew_today": "Reactivate the subscription and charge today.",
	"autorec_renew_original_date": "Reactivate the subscription and charge on the next scheduled date.",
	"autorec_renew_today_selected": "By selecting this option, future billing dates will also be updated.",
	"autorec_renew_original_date_selected": "By selecting this option, the billing dates will be maintained according to the subscription creation.",
	"autorec_renew_will_happen_today": "The charge will occur today.",
	"autorec_charge_provisioning": "Charge",
	"autorec_charge_provisioning_title": "Do you want to charge this renewal?",
	"autorec_charge_provisioning_text": "",
	"autorec_extend": "Extend",
	"autorec_extend_provisioning": "Extend renewal",
	"autorec_extend_provisioning_dates": "The cancel date must be earlier than the next billing date.",
	"autorec_extend_to": "Select the new cancellation date:",
	"autorec_update_billing_date": "Edit billing date",
	"autorec_update_billing_date_error": "The billing date must be earlier than the cancel date.",
	"autorec_update_billing_date_to": "Select the new billing date:",
	"autorec_update_billing_date_overwrite_cycle_normal": "Change billing date specifically",
	"autorec_update_billing_date_overwrite_cycle_overwrite": "Overwrite all billing dates from this renewal",
	"autorec_update_billing_date_overwrite_cycle_normal_info": "The following billing dates will be kept according to the subscription cycle.",
	"autorec_update_billing_date_overwrite_cycle_overwrite_info": "The following billing dates will be overwritten to the new billing date.",

	"autorec_more_future_charges": "More future charges",
	"autorec_more_past_charges": "More previous charges",
	"autorec_next_provisioning": "Show next 3 charges",
	"autorec_consolidate_provisioning": "Consolidate provisionings",

	"autorec_status_active": "Active",
	"autorec_status_inactive_only": "Inactive",
	"autorec_status_new": "Waiting for first payment",
	"autorec_status_rec": "Pending payment",
	"autorec_status_inactive": "Inactive / Cancelled",
	"autorec_status_expired": "Expired",
	"autorec_status_paused": "Paused",
	"autorec_status_overdue": "Late payment",
	"autorec_status_provisionado": "Pending",
	"autorec_status_efetuado": "Processed",
	"autorec_status_completado": "Completed",
	"autorec_status_cancelado": "Cancelled",
	"autorec_status_pulado": "Skipped",
	"autorec_status_isento": "Exempt",

	"autorecnot_title": "Notifications",
	"autorec_copy_email_to": "Copy e-mail to",
	"autorec_copy_email_to_desc": "Receive a copy when a notification is sent to your customer",
	"autorec_copy_email_notification": "Notifications to receive a copy",
	"autorec_activation": "Activation",
	"autorec_reminder": "Credit Card Reminder",
	"autorec_reminder_adicional": "Payment Link Reminder",
	"autorec_payment_link": "Payment Link",
	"autorec_cancellation": "Cancellation",
	"autorec_confirmation": "Confirmation",
	"autorec_charge_payment": "Payment information",
	"autorec_charge_error": "Error",
	"autorec_last_charge_date": "Last charge date",
	"autorec_next_charge_date": "Next charge date",
	"autorec_charge_attempts": "Attempts",
	"autorec_charge_payment_method": "Payment method",
	"autorec_allow_edit_item": "Edit on subscriber portal",
	"autorec_user": "User",
	"autorec_type": "Type",
	"autorec_date": "Date",
	"autorec_update": "Update",
	"autorec_provisioning_update": "Provisioning update",
	"autorec_tentativa": "Charge attempt",
	"autorec_cancelled_by": "Cancelled by",
	"autorec_subscriptionupdate": "Subscription update",
	"autorec_subscriptionpaused": "Subscription paused",
	"autorec_information": "Information",
	"autorec_is_unlimited": "(0 is unlimited)",

	"autorecshipping_title": "Shipping Cycles",
	"autorecfreq_title": "Billing Cycles",
	"autorecfreq_id": "ID",
	"autorecfreq_frequency": "Cycle code",
	"autorecfreq_each": "Every",
	"autorecfreq_units": "Units",
	"autorecfreq_interval": "Interval",
	"autorecfreq_quantity": "Quantity",

	"autorecreports_title": "Reports",
	"autorecreports_select": "Selecione uma opção de relatório",
	"autorecreports_subscription": "Assinaturas",
	"autorecreports_subscription_products": "Assinaturas - Produtos",
	"autorecreports_current_overdues": "Assinaturas com pagamentos atrasados",
	"autorecreports_history_overdues": "Histórico de pagamentos atrasados",
	"autorecreports_preview": "Preview",
	"autorecreports_generate": "Generate CSV",
	"autorecreports_filters": "Filters",
	"autorecreports_start_date": "Start Date",
	"autorecreports_end_date": "End Date",
	"autorecreports_subscription_number": "Subscription",
	"autorecreports_subscription_status": "Subscription status",
	"autorecreports_status": "Status",
	"autorecreports_amount": "Amount",
	"autorecreports_data_insercao": "Insert date",
	"autorecreports_data_prox_cobranca": "Next billing date",
	"autorecreports_frequency": "Frequency",
	"autorecreports_quantidade_gerado": "Renewals count",
	"autorecreports_skipped_count": "Skipped count",
	"autorecreports_prev_saved": "Subscription Token",
	"autorecreports_user_cancel": "Cancelled by",
	"autorecreports_data_cancelamento_efetivo": "Cancellation date",
	"autorecreports_motivo_cancelamento": "Cancellation Reason",
	"autorecreports_customer_email": "Email",
	"autorecreports_customer_taxid": "CPF/CNPJ",
	"autorecreports_customer_phone": "Phone Number",
	"autorecreports_customer_name": "Name",
	"autorecreports_customer_city": "City",
	"autorecreports_customer_state": "State",
	"autorecreports_product_sku": "SKU",
	"autorecreports_product_name": "Product",
	"autorecreports_product_amount": "Unit amount",
	"autorecreports_product_quantity": "Quantity",
	"autorecreports_product_discount": "Discount",
	"autorecreports_overdues": "Quantity of late payments",
	"autorecreports_min_recorrencia": "First late recurrence",
	"autorecreports_max_recorrencia": "Last late recurrence",
	"autorecreports_report_preview": "Report preview",
	"autorecreports_export_total": "Total to be exported",
	"autorecreports_rows": "record(s)",
	"autorecreports_empty_rows": "There are no records in this report",

	"autorecproduct_title": "Products",
	"autorecproduct_active_products": "Actives",
	"autorecproduct_inactive_products": "Inactives",
	"autorecproduct_select": "Select one or more billing cycles",
	"autorecproduct_frequency": "Billing cycle",
	"autorecproduct_shipping_cycle": "Shipping cycle",
	"autorecproduct_frequencies": "billing cycles",
	"autorecproduct_settings": "Product settings",
	"autorecproduct_disable_on_empty_freq": "The product must have a billing cycle to be available in PagStream. It will be disabled if you don't add one.",
	"autorecproduct_filter": "Filter",
	"autorecproduct_filter_clear": "Clear",
	"autorecproduct_filter_by": "Filter by",
	"autorecproduct_filter_product_name": "Product name",
	"autorecproduct_filter_product_sku": "Product SKU",
	"autorecproduct_filter_product_amount": "Product amount",
	"autorecproduct_filter_frequencies": "Billing cycles",
	"autorecproduct_unable_to_delete": "Unable to delete",
	"autorecproduct_currently_in_use": "The billing cycle can't be deleted because it was used to create subscriptions.",
	"autorecproduct_no_active_products": "No active products",
	"autorecproduct_no_inactive_products": "No inactive products",
	"autorecproduct_none": "None",

	"autorecfreq_title": "Billing Cycles",
	"autorecfreq_id": "ID",
	"autorecfreq_frequency": "Cycle code",
	"autorecfreq_quantidade": "Units",
	"autorecfreq_intervalo": "Interval",
	"autorecfreq_periodicity": "Cycle periodicity",
	"autorecfreq_dia_lembrete": "Credit card reminder (days)",
	"autorecfreq_dia_lembrete_adicional": "Payment link reminder (days)",
	"autorecfreq_days_to_cancel": "Days after billing until cancellation",
	"autorecfreq_days_to_cancel_desc": "Define how many days after the billing date an unpaid subscription is cancelled.",
	"autorecfreq_days_to_cancel_desc_start": "Unpaid subscriptions are cancelled in",
	"autorecfreq_days_to_cancel_desc_end": "after the billing date.",
	"autorecfreq_days_to_cancel_max": "Maximum days to be configured:",
	"autorecfreq_pix_rec_retry_number": "Automatic Pix Retry Number",
	"autorecfreq_pix_rec_retry_number_desc": "Define the number of retries for Automatic Pix payments.",
	"autorecfreq_acoes": "Actions",
	"autorecfreq_remember_days": "Number of days a payment reminder is sent prior the billing date.",
	"autorecfreq_remember_days_aditional": "Number of days a payment link reminder is sent prior the cancellation date.",
	"autorecfreq_error_msg_empty": "Please complete the all required fields.",
	"autorecfreq_error_limit_day_5": "The period must be at least 5 days.",
	"autorecfreq_error_delete": "This billing cycle can't be deleted because it's linked to a subscription.",

	"autorecprom_title": "Promotion Engine",
	"autorecprom_id": "Id",
	"autorecprom_titulo": "Rule name",
	"autorecprom_status": "Status",
	"autorecprom_num_renovacao": "Execution limit",
	"autorecprom_acoes": "Action",
	"autorecprom_error_msg_empty": "Please complete the all required fields.",
	"autorecprom_rules": "Rules",
	"autorecprom_discount": "Discount",
	"autorecprom_rule_tipo": "Type",
	"autorecprom_valor_maior_que": "Amount greater than",
	"autorecprom_valor_maior_menos_frete": "Amount(less shipping) greater than",
	"autorecprom_contem_produto": "Contains product",
	"autorecprom_endereco_estado": "Address state",
	"autorecprom_renovacao_numero": "Execution limit",
	"autorecprom_periodo_criacao": "Subscription created between",
	"autorecprom_desconto_total": "Total discount",
	"autorecprom_desconto_frete": "Shipping discount",
	"autorecprom_inclusao_produto": "Product inclusion",
	"autorecprom_desconto_produto": "Product discount",
	"autorecprom_discount_percentual": "Percentage",
	"autorecprom_num_renovacao_info": "It defines the number of renewals the promotion will be applied to, when a subscription matches the rule.",
	"autorecprom_rule_product": "Product",
	"autorecprom_rule_valor": "Amount",
	"autorecprom_save_success": "Promotion rule updated successfully.",
	"voce_quer_ativar_esta_promocao": "Do you really want to activate this promotion?",
	"voce_quer_inativar_esta_promocao": "Do you really want to inactivate this promotion?",
	"autorecset_limit_warn_promo": "(0 is unlimited).",

	"autorecprom_event_general_title": "General Events",
	"autorecprom_event_rules_title": "Rules Events",
	"autorecprom_event_discounts_title": "Discounts Events",
	"autorecprom_event_line": "Line",
	"autorecprom_event_field": "Field",
	"autorecprom_event_old_value": "Old Value",
	"autorecprom_event_new_value": "New Value",

	"autorecnewprom_new": "New",
	"autorecnewprom_edit": "Edit",
	"autorecnewprom_promotion": "Promotion",
	"autorecnewprom_promotion_subscription": "Subscription",
	"autorecnewprom_promotion_subscriptions": "Subscriptions",
	"autorecnewprom_promotion_rule": "promotion rule",
	"autorecnewprom_promotion_rulename": "Rule name",
	"autorecnewprom_promotion_review": "Review your promotion",
	"autorecnewprom_promotion_rulemaxrec": "Number of renewals",
	"autorecnewprom_promotion_when_match": "When a subscription matches...",
	"autorecnewprom_promotion_unlimited": "(unlimited)",
	"autorecnewprom_promotion_percentage": "Percentage",
	"autorecnewprom_promotion_status": "Status",
	"autorecnewprom_promotion_value": "Amount",
	"autorecnewprom_promotion_type": "Type",
	"autorecnewprom_promotion_activated": "Active",
	"autorecnewprom_promotion_activate": "Activate",
	"autorecnewprom_promotion_activatef": "activated",
	"autorecnewprom_promotion_desactivated": "Inactive",
	"autorecnewprom_promotion_desactivate": "Inactivate",
	"autorecnewprom_promotion_desactivatef": "inactivated",
	"autorecnewprom_promotion_amount": "Amount",
	"autorecnewprom_promotion_recnumber": "Renewal number",
	"autorecnewprom_promotion_province": "Address state",
	"autorecnewprom_promotion_aprovince": "Address state",
	"autorecnewprom_promotion_date": "Date",
	"autorecnewprom_billing_date": "Billing date",
	"autorecnewprom_promotion_operator": "Operator",
	"autorecnewprom_promotion_operator_greater": "greater than",
	"autorecnewprom_promotion_operator_less": "less than",
	"autorecnewprom_promotion_operator_contains": "contains",
	"autorecnewprom_promotion_operator_equals": "equals",
	"autorecnewprom_promotion_operator_between": "between",
	"autorecnewprom_promotion_product": "Product",
	"autorecnewprom_promotion_and": "+",
	"autorecnewprom_promotion_then": "Then...",
	"autorecnewprom_promotion_action": "Action",
	"autorecnewprom_promotion_save": "Save",
	"autorecnewprom_promotion_close": "Close",
	"autorecnewprom_promotion_greater_then": "Total amount",
	"autorecnewprom_promotion_greater_then_shipping": "Total amount (without shipping fee)",
	"autorecnewprom_promotion_product_amount": "Product amount",
	"autorecnewprom_promotion_contains_products": "Products",
	"autorecnewprom_promotion_renewal": "Renewal number",
	"autorecnewprom_promotion_date": "Subscription creation date",
	"autorecnewprom_promotion_date_and": "and",
	"autorecnewprom_promotion_initial_date": "Start date",
	"autorecnewprom_promotion_final_date": "End date",
	"autorecnewprom_subscriptions_empty": "No subscriptions",
	"autorecnewprom_subscriptions_message_activate": "Do you want to activate this promotion?",
	"autorecnewprom_subscriptions_message_desactivate": "Do you want to desactivate this promotion?",
	"autorecnewprom_promotion_error_no_name": "You cannot save promotions with empty name.",
	"autorecnewprom_promotion_error_no_rules": "You cannot save promotions with empty rules.",
	"autorecnewprom_promotion_error_no_discounts": "You cannot save promotions with empty discounts.",

	"autorecautomation_id": "Id",
	"autorecautomation_empty": "There are no results",
	"autorecautomation_titulo": "Rule name",
	"autorecautomation_targets": "Targets",
	"autorecautomation_target_type": "Target type",
	"autorecautomation_acoes": "Action",
	"autorecautomation_available": "Available",
	"autorecautomation_queued": "Queued",
	"autorecautomation_running": "Running",
	"autorecautomation_title": "Automation",
	"autorecautomation_valor": "Total amount",
	"autorecautomation_valor_sem_frete": "Total amount (without shipping fee)",
	"autorecautomation_produto": "Product",
	"autorecautomation_status": "Status",
	"autorecautomation_desconto_produto": "Product discount",
	"autorecautomation_numero": "Quantity of recurrences",
	"autorecautomation_num_recorrencia": "Recurrence number",
	"autorecautomation_estado": "Address state",
	"autorecautomation_data": "Creation date",
	"autorecautomation_next_billing_date": "Next billing date",
	"autorecautomation_billing_date": "Billing date",
	"autorecautomation_product_amount": "Product amount",
	"autorecautomation_percentual": "Percentage (%)",
	"autorecautomation_operator": "Operator",
	"autorecautomation_operator_greater": "greater than",
	"autorecautomation_operator_less": "less than",
	"autorecautomation_operator_contains": "contains",
	"autorecautomation_operator_not_contains": "not contains",
	"autorecautomation_operator_equals": "equals",
	"autorecautomation_operator_between": "between",
	"autorecautomation_when_match": "When a subscription matches...",
	"autorecautomation_tipo": "Type",
	"autorecautomation_and": "+",
	"autorecautomation_initial_date": "Start date",
	"autorecautomation_final_date": "End date",
	"autorecautomation_save": "Save",
	"autorecautomation_then": "Then...",
	"autorecautomation_action": "Action",
	"autorecautomation_remover_produto": "Remove product",
	"autorecautomation_adicionar_produto": "Include product",
	"autorecautomation_substituir_produto": "Replace product",
	"autorecautomation_cancelar": "Cancel",
	"autorecautomation_replaced": "To be replaced",
	"autorecautomation_replace": "To replace",
	"autorecautomation_by": "by",
	"autorecautomation_alterar_valor_produto": "Change product amount",
	"autorecautomation_alterar_desconto_produto": "Change product discount",
	"autorecautomation_alterar_desconto_frete": "Change shipping discount",
	"autorecautomation_error_automation": "You need to define a title to your automation",
	"autorecautomation_error_no_filter": "You cannot save automations with empty filter.",
	"autorecautomation_error_no_actions": "You cannot save automations with empty actions.",
	"autorecautomation_review": "Review your automation",
	"autorecautomation_close": "Close",
	"autorecautomation_execute": "Execute",
	"autorecautomation_incluir": "New automation rule",
	"autorecautomation_alterar": "Edit automation rule",

	"ph_xppnome": "Company name",
	"ph_storeurl": "Store URL",
	"ph_email": "Contact e-mail",
	"ph_order_number": "Order number",
	"ph_payment_method": "Payment method",
	"ph_amount_brl": "Amount BRL",
	"ph_boleto_code": "Boleto code",
	"ph_submission_date": "Submission date",
	"ph_product_name": "Product name",
	"ph_products_list": "Product list (quantity, name and amount)",
	"ph_url_cobranca": "Billing URL (Payment Link)",
	"ph_expiration_date": "Expiration date",
	"ph_auto_generated": "Original order number",
	"ph_customer_taxid": "Customer taxId",
	"ph_customer_name": "Customer name",
	"ph_customer_email": "Customer e-mail",
	"ph_customer_phone": "Customer phone",
	"ph_customer_street": "Customer street",
	"ph_customer_zip": "Customer zip",
	"ph_customer_city": "Customer city",
	"ph_customer_state": "Customer state",
	"ph_url_cancel": "URL to cancel",
	"ph_rule_type": "Rule type",
	"ph_rule_product": "Rule product",
	"ph_rule_frequency": "Rule frequency",
	"ph_billing_date": "Billing date",
	"ph_cancellation_reason": "Cancellation reason",

	"title_account_estab_comercial": "Merchant",
	"ec_merchant_number": "Merchant Code",
	"ec_name": "Name",
	"ec_cnpj": "CNPJ",
	"ec_status": "Status",
	"ec_response": "Response",
	"ec_confirmation_code": "Confirmation Code",
	"ec_pending": "Pending",
	"ec_success": "Success",
	"ec_update": "Update",
	"ec_error": "Error",
	"ec_tipo_usuario": "Tipo de Usuário",
	"ec_status": "Status",
	"ec_bloqueio_liquidacao": "Bloqueio Liquidação",
	"ec_protocolo": "Protocolo",
	"ec_telefone": "Telefone",
	"ec_celular": "Celular",
	"ec_tipo_conta": "Tipo Conta",
	"ec_banco": "Banco",
	"ec_agencia": "Agência",
	"ec_numero_conta": "Número Conta",
	"ec_erro": "Erro",
	"ec_status_cerc": "Status CERC",

	"title_unidade_recebivel": "Receivable Units",
	"ur_id": "Id",
	"ur_reference": "Reference",
	"ur_merchant": "Merchant",
	"ur_status": "Status",
	"ur_type": "Type",
	"ur_scheme_code": "Scheme Code",
	"ur_gross_amount": "Gross Amount",
	"ur_net_amount": "Net Amount",
	"ur_processing_date": "Processing Date",
	"ur_confirmation_code": "Confirmation Code",
	"ur_ativo": "Active",
	"ur_to_be_update": "To Be Updated",
	"ur_updated": "Updated",
	"ur_create_unit": "Create Unit",
	"ur_update_unit": "Update Unit",
	"ur_deactivate": "Deactivate",
	"ur_void": "Void",
	"ur_referencia_externa": "Referência Externa",
	"ur_cnpj_credenciadora": "CNPJ Credenciadora",
	"ur_cnpj_recebedor": "CNPJ Recebedor",
	"ur_date": "Data",
	"ur_status": "Status",
	"ur_tipo_operacao": "Tipo Operação",
	"ur_cod_arranjo": "Cod. Arranjo",
	"ur_valor_bruto": "Valor Bruto",
	"ur_valor_constituido": "Valor Constituído",
	"ur_valor_constituido_pre": "Valor Pré-Const.",
	"ur_valor_bloqueado": "Valor Bloqueado",
	"ur_valor_liquido": "Valor Líquido",
	"ur_valor_liquido_efetivo": "Valor Líq. Efetivo",
	"ur_data_liquidacao": "Data Liquidação",
	"ur_data_liq_efetiva": "Data Liq. Efetiva",
	"ur_data_processamento": "Data Processamento",
	"ur_protocolo": "Protocolo",

	"title_pos_contratada": "Post-contracted",
	"pc_id": "Id",
	"pc_reference": "Reference",
	"pc_type": "Type",
	"pc_scheme_code": "Scheme Code",
	"pc_anticipated_amount": "Anticipated Amount",
	"pc_processing_date": "Processing Date",
	"pc_confirmation_code": "Confirmation Code",
	"pc_create_contract": "Create Contract",
	"pc_update_contract": "Update Contract",
	"pc_deactivate": "Deactivate",
	"pc_void": "Void",
	"pc_tipo_operacao": "Tipo de Operação",
	"pc_referencia_externa": "Referência Externa",
	"pc_cnpj_credenciadora": "CNPJ Credenciadora",
	"pc_cnpj_recebedor": "CNPJ Recebedor",
	"pc_codigo_arranjo": "Cód. Arranjo",
	"pc_data_liquidacao": "Data Liquidação",
	"pc_data_contrato_antecipacao": "Data Contrato Antec.",
	"pc_valor_antecipado": "Valor Antecipado",
	"pc_valor_constituido_antecipado": "Valor Constituído Antec.",
	"pc_identificador_operacao": "Identificar Operação",
	"pc_instituicao_credenciadora_arranjo": "Instituição Cred. Arranjo",
	"pc_cnpj_titular": "CNPJ Titular",
	"pc_tipo_conta": "Tipo de Conta",
	"pc_banco": "Banco",
	"pc_agencia": "Agência",
	"pc_numero_conta": "Número da Conta",
	"pc_valor_pago": "Valor Pago",
	"pc_data_pagamento": "Data Pagamento",
	"pc_protocolo": "Protocolo",

	"uo_title": "Order Administration",
	"uo_msg_sucesso": "Successful",
	"uo_msg_warning": "Warning",
	"uo_msg_warning_find_order": "Order is not found",
	"uo_msg_insert_admorder": "Insert",
	"uo_msg_update_admorder": "Update",

	"uo_aba_principal": "Principal Information",
	"uo_aba_cliente": "Customer Information",
	"uo_aba_boleto": "Boleto Information",
	"uo_aba_complementar": "Additional Information",
	"uo_aba_pagamento": "Payment Information",
	"uo_aba_cartao": "Card Information",
	"uo_aba_cotacao": "Price Information",
	"uo_aba_fee": "Fee Information",
	"apply_order_rules": "Apply order rules",

	//principais
	"uo_order_number": "Order Number",
	"uo_internal_number": "Internal Number",
	"uo_payment_method": "Payment Method",
	"uo_status": "Status",
	"uo_amount": "Amount",
	"uo_submission_date": "Submission date",
	"uo_product": "Product",
	"uo_param_url": "URL Parameter",
	"uo_due_date": "Due Date",

	//cliente
	"uo_customer_name": "Customer name",
	"uo_customer_taxid": "Tax ID",
	"uo_customer_email": "E-mail",
	"uo_customer_phone": "Phone",
	"uo_customer_address": "Address",
	"uo_customer_postalcode": "Postal Code",
	"uo_customer_state": "State",
	"uo_customer_city": "City",

	//boleto
	"uo_boleto_code": "Boleto Code",
	"uo_urlbol": "URL Boleto",

	//complementares
	"uo_shop_code": "Shop Code",
	"uo_nf": "NF",
	"uo_url_return": "URL Return",
	"uo_custom": "Custom",
	"uo_score": "Score",
	"uo_api": "API",
	"uo_gateway": "Gateway",
	"uo_erro": "Error",
	"uo_auto_generated": "Auto Generated",
	"uo_ordem_original": "Original Order",
	"uo_percentual": "Percentual",
	"uo_payment_option": "Payment Option",
	"uo_authentication": "Authentication",
	"uo_authentication_onfailure": "Authentication Onfailure",
	"uo_verificador": "Verificador",
	"uo_products_list": "Products list",

	//pagamento
	"uo_pay_date": "Payment Date",
	"uo_amt_paid": "Amount Paid",
	"uo_amt_refnd": "Amount Refund",
	"uo_refd_date": "Refund Date",
	"uo_refd_info": "Refund Info",
	"uo_rep_date": "Report Date",
	"uo_repref_dt": "Report Refund Date",
	"uo_confirmation_date": "Confirmation Date",

	//dados de cartão
	"uo_nsu": "NSU",
	"uo_tid": "TID",
	"uo_aut_code": "Authorization Code",
	"uo_cc_inst": "CC Inst",
	"uo_cc_brand": "CC Brand",
	"uo_cc_auth": "CC Auth",
	"uo_cc_holder": "CC Holder",
	"uo_cc_number": "CC Number",
	"uo_cc_token": "CC Token",
	"uo_cc_exp": "CC Exp",
	"uo_cc_bin": "CC Bin",

	//cotacao garantida
	"uo_fx_amount": "Fx Amount",
	"uo_fx_refunded": "Fx Amount Refund",
	"uo_fx_rate": "Fx Rate",
	"uo_fx_rate_refund": "Fx Rate Refund",
	"uo_fx_currency": "Fx Currency",

	//fee
	"uo_fee": "Fee",
	"uo_fee_ref": "Fee Refund",
	"uo_feesp": "Fee SP",
	"uo_feeja": "Fee Advance Interest",
	"uo_fix": "Fix",
	"uo_feepb": "Fee PB",
	"uo_markup_fix": "Markup Fix",

	"title_efeito_contrato": "Contract in Effect",
	"efec_id": "Id",
	"efec_remittance_date": "Remittance Date",
	"efec_free_amount": "Free Amount",
	"efec_confirmation_code": "Confirmation Code",
	"efec_documento_titular": "Documento Titular",
	"efec_data_liquidacao": "Data Liquidação",
	"efec_constituicao": "Constituição",
	"efec_valor_livre": "Valor Livre",
	"efec_protocolo": "Protocolo",
	"efec_indicador_efeitos_contrato": "Indicador efeitos contr.",
	"efec_cnpj_entidade_registradora": "CNPJ Entidade Reg.",
	"efec_tipo_efeito": "Tipo de Efeito",
	"efec_cnpj_beneficiario_titular": "CNPJ Benef. Titular",
	"efec_regra_divisao": "Regra Divisão",
	"efec_valor_comprometido": "Valor Comprometido",
	"efec_numero_documento_titular": "Número Doc. Titular",
	"efec_tipo_conta": "Tipo de Conta",
	"efec_ispb": "ISPB",
	"efec_agencia": "Agência",
	"efec_numero_conta": "Número de Conta",
	"efec_banco": "Banco",

	"gw_title": "Gateway Report",
	"gwrep_id": "Id",
	"gwrep_order_number": "Order Number",
	"gwrep_data_insercao": "Insert Date",
	"gwrep_epoch": "Epoch",
	"gwrep_report_date": "Report Date",
	"gwrep_fee": "Fee",
	"gwrep_tipo": "Type",
	"gwrep_acao": "Action",
	"gwrep_auth_request": "Authorization request",
	"gwrep_auth_capture_request": "Authorization/Capture request",
	"gwrep_refund_request": "Refund request",
	"gwrep_capture_request": "Capture request",
	"gwrep_pb_debit_credit": "PagBrasil debit/credit",
	"gwrep_token_service_request": "Tokenization service request",
	"gwrep_token_service_use": "Tokenization service use",
	"gwrep_undefined": "Undefined",

	"ps_title": "PagShield Report",
	"ps_id": "Id",
	"ps_shd_order": "Order Number",
	"ps_shd_bol": "Code",
	"ps_shd_epoch": "Epoch",
	"ps_shd_date": "Date",
	"ps_rep_fee": "Report Date",
	"ps_screening": "Screening",
	"ps_shd_score": "Score",
	"ps_shd_act": "Action",
	"ps_shd_fee": "Fee",
	"ps_shd_fee_total": "Total Fee",

	"remittance_report_title": "Remittance Report",
	"remittance_title": "Remittance",
	"remittance_merchant": "Merchant",
	"remittance_base_date": "Base Date",
	"remittance_last_settlement": "Return the last settlement generated",
	"remittance_status": "Status",
	"remittance_quantidade": "Qty.",
	"remittance_total": "Total",

	"remittance_data_arquivo": "Date",
	"remittance_valor_bruto": "Amount Paid",
	"remittance_valor_fee": "Fees",
	"remittance_valor_refund": "Refunds",
	"remittance_valor_cb": "Chargebacks",
	"remittance_valor_cd_gateway": "Valor CD Gateway",
	"remittance_valor_liquido": "Net Amount",
	"remittance_valor_remessa": "Remittance",
	"remittance_valor_reserva": "Reserve",
	"remittance_valor_reserva_anterior": "Last Reserve",
	"remittance_valor_processado": "Processed",

	"remittance_data_pagamento_fw": "Data Pagamento",
	"remittance_favorecido_fw": "Favorecido",
	"remittance_valor_fee_fw": "Valor Fee",
	"remittance_valor_repasse_fw": "Valor Repasse",

	"remittance_valor_total": "Total amount",
	"remittance_valor_pago_total": "Total amount paid",
	"remittance_valor_reembolso_total": "Total refund",
	"remittance_fee_total": "Total fee",
	"remittance_fee_reembolso_total": "Total fee refund",
	"remittance_dado_adicionado_report": "Data that will be add to pbreport",
	"remittance_arquivo": "File",
	"remittance_currency": "Currency",
	"remittance_valor_liquido": "Net Amount",
	"remittance_valor_bruto": "Total Amount",
	"remittance_total_chargeback": "Total Chargeback",
	"remittance_total_processed": "Total Processed",
	"remittance_total_reserve": "Total Reserve",
	"remittance_valor_remessa": "Remittance Amount",
	"remittance_fx_rate": "FX Rate",
	"remittance_atualizar_fee": "Update Fee",
	"remittance_linha_report": "Report Line",
	"remittance_gerar_csv": "Generate CSV",
	"remittance_vincular_ordens": "Associate Orders",
	"remittance_comparar": "Compare",
	"remittance_acao": "Action",
	"remittance_ajuste": "Adjustment",
	"remittance_undo": "Undo Remittance",
	"remittance_tooltip_process": "Execute the complete process to all listed merchants",
	"remittance_tooltip_linha_report": "Insert a line in pbreport.dbf and insert a register in mysql",
	"remittance_tooltip_gerar_csv": "Generate CSV file and register a snapshot in mysql",
	"remittance_tooltip_vincular_ordens": "Flag the orders as belonging to this report. rep_date and repref_dt",
	"remittance_tooltip_comparar": "Compare to the old system",
	"remittance_tooltip_atualizar_fee": "Update the gateway registers fees that are not internal",
	"remittance_tooltip_undo": "Undo the remittance",
	"remittance_summary": "Processing Summary",

	"fee_remittance_title": "Minimum Fee",
	"fee_remittance_tipo": "Type",

	"title_remittance_anticipation": "Remittance Anticipation",
	"remittance_anticipation_list": "List",
	"remittance_anticipation_status": "Status",
	"remittance_anticipation_data_insercao": "Insert date",
	"remittance_anticipation_data_antecipacao": "Anticipation initial date",
	"remittance_anticipation_data_deposito": "Deposit date",
	"remittance_anticipation_data_para_relatorio": "Date to report",
	"remittance_anticipation_valor_solicitado": "Requested amount",
	"remittance_anticipation_valor_bruto": "Gross amount",
	"remittance_anticipation_valor_final": "Final amount",
	"remittance_anticipation_acoes": "Actions",
	"remittance_anticipation_status_waiting": "Waiting",
	"remittance_anticipation_status_approved": "Approved",
	"remittance_anticipation_status_rejected": "Rejected",

	"remittance_anticipation_field_order_number": "Order number",
	"remittance_anticipation_field_status": "Status",
	"remittance_anticipation_field_efeito_contrato": "Contract Effect",
	"remittance_anticipation_field_amt_paid": "Amt. paid",
	"remittance_anticipation_field_amt_refnd": "Amt. refund",
	"remittance_anticipation_field_order_fee": "Fee",
	"remittance_anticipation_field_order_fee_ref": "Fee refund",
	"remittance_anticipation_field_order_data_repasse": "Remittance date",
	"remittance_anticipation_field_order_amt_anticipation": "Amt. anticipation",

	"remittance_anticipation_button_preview_anticipation": "Preview",
	"remittance_anticipation_total_anticipation": "Total amount of anticipation: ",
	"remittance_anticipation_button_request_anticipation": "Request anticipation",
	"remittance_anticipation_type": "Type",
	"remittance_anticipation_taxa_adiantamento": "Monthly anticipation fee",
	"remittance_anticipation_taxa_adicional": "Aditional fee",
	"remittance_anticipation_feeremit": "Remittance fee",

	"title_repasse_agendado": "Remittance Release Schedule",
	"repasseagendado_calendar": "Calendar",
	"repasseagendado_movements": "Transactions",
	"repasseagendado_id": "Id",
	"repasseagendado_arquivo" : "Report",
	"repasseagendado_order_number": "Order",
	"repasseagendado_status": "Status",
	"repasseagendado_valor": "Amount (BRL)",
	"repasseagendado_data_insercao": "Payment Date",
	"repasseagendado_data_liberacao": "Release Date",
	"repasseagendado_data_previsao": "Prediction Date",
	"repasseagendado_payment_method": "Payment Method",
	"repasseagendado_mes_filtro": "Month",
	"repasseagendado_liberado": "Release",
	"repasseagendado_previsto": "Prediction",
	"repasseagendado_resultado_futuro": "Future results",

	"catalogo_title": "Product catalog",
	"catalogo_categoria_title": "Categories",
	"catalogo_categoria_name": "Name",
	"catalogo_categoria_erro": "This category can not be deleted.",

	"catalogo_produto_title": "Products",
	"catalogo_produto_sku": "SKU",
	"catalogo_produto_name": "Name",
	"catalogo_produto_description": "Description",
	"catalogo_produto_image_link": "Image link",
	"catalogo_produto_amount": "Amount",
	"catalogo_produto_categoria_id": "Category",
	"catalogo_produto_erro": "This product can not be deleted.",

	"proforma_conta_fechada": "Incluir contas fechadas",
	"proforma_maior_min_remittance": "Maior que min. remittance",
	"proforma_aglutinar": "Aglutinar",
	"proforma_agrupamento": "Agrupamento",
	"proforma_pre_geracao": "Pré Geração",
	"proforma_finalizacao": "Finalização",
	"proforma_separar": "Separar",
	"proforma_merchant": "Merchant",
	"proforma_currency": "Currency",
	"proforma_min_remittance": "Min. Remittance",
	"proforma_pending_amount": "Pending Amount (BRL)",
	"proforma_pending_remittance": "Pending Remittance",
	"proforma_status": "Status",
	"proforma_fazer": "Action",
	"proforma_valor_calculado": "Valor Calculado",
	"proforma_data_base": "Base date",
	"proforma_empty_base_date": "Empty base date",

	"invoice_gerar": "Generate invoice",
	"invoice_pre_gerar": "Pré generate invoice",
	"invoice_merchant": "Merchant",
	"invoice_currency": "Currency",
	"invoice_valor_remessa": "Remittance amount",
	"invoice_valor_processado": "Processed amount",
	"invoice_data_arquivo": "Report date",
	"invoice_fazer": "Action",
	"payment_invoice_title": "Invoice Payment",
	"invoice_fee_value": "Fee Value",
	"invoice_confirm_title": "Confirm Invoice Generation",
	"invoice_confirm_message": "Do you really want to generate invoices for the selected merchants?",
	"invoice_confirm_count": "Number of selected merchants",
	"invoice_date_required": "Please inform the invoice date.",
	"invoice_no_selection": "Please select at least one merchant to generate the invoice.",
	"invoice_success": "Invoices generated successfully!",

	"processment_title": "Processment",
	"processment_merchant": "Merchant",
	"processment_currency": "Currency",
	"processment_data_arquivo": "Date",
	"processment_last_valor_remessa": "Last remit. amount",
	"processment_last_valor_reserva": "Last reserve",
	"processment_next_valor_reserva": "Next reserve",
	"processment_valor_remessa": "Remit. amount",
	"processment_valor_processado": "Process amount",
	"processment_fazer": "Action",
	"processment_pre_repasse_gerado": "Pré-repasse",
	"processment_invoice": "Invoice",

	"operacao_cancelada": "Operation cancelled.",
	"operacao_concluida": "Operation completed.",
	"voce_tem_certeza": "Are you sure?",
	"voce_tem_certeza_excluir": "Do you want to delete the account ",
	"processo_irreversivel": "This process is irreversible.",
	"remove_conteudo": "Do you want to delete ALL orders and keep the configuration for account ",
	"voce_quer_excluir": "Do you want to delete this item?",
	"voce_quer_atualizar": "Do you want to update this item?",
	"exclusao_sucesso": "Delete done successfully.",
	"inclusao_sucesso": "Insert done successfully.",
	"alteracao_sucesso": "Update done successfully.",
	"erro_indefinido": "Undefined error.",
	"warning_opening_link": "Warning: This is an external link that was not validated by PagBrasil and may contain malicious content.",

	"search_merchant": "Search Merchant",
	"filter_nota_gerada": "Nota Gerada",
	"search": "Search",
	"filter": "Filter",
	"tipo": "Tipo",
	"periodo": "Period",
	"select_periodo": "Select Period.",
	"select_date": "Select date.",
	"total": "Total",
	"Quant": "Qty.",
	"test_upper": "TEST",
	"closed_upper": "CLOSED",
	"amount_brl": "Amount (BRL)",
	"pec_code": "PEC Code",
	"pix_image": "Pix QR Code (Image URL)",
	"pix_qrcode": "Pix QR Code (Image)",
	"source_code": "Source Code",
	"submit_all": "Submit All",
	"actions": "Actions",
	"show_more": "Show more",

	"add_payment_option": "Include all",
	"remove_payment_option": "Remove all",

	"choose": "* choose",
	"sorry_no_match": "Sorry, no matching options.",

	"calendario": "Calendar",
	"listagem": "Browse",
	"incluir": "Add",
	"alterar": "Update",
	"confirm": "Confirm",
	"eventos": "Events",
	"true": "True",
	"false": "False",
	"show": "Show",
	"hide": "Hide",
	"action": "Action",
	"date_format": "Date Format",
	"yes": "Yes",
	"no": "No",
	"Ativo": "Activated",
	"Inativo": "Deactivated",
	"created_at": "Created at",
	"updated_at": "Updated at",
	"ON": "ON",
	"OFF": "OFF",
	"Success": "Success",
	"All": "All",
	"recycle": "Recycle",
	"of": "of",
	"today": "Today",
	"range_to": "to",
	"limit": "Limit",
	"old": "Old",
	"new": "New",
	"new_ignore_i": "Transaction Rev.",
	"subtracao": "Subtraction",
	"adicao": "Addition",
	"consolidate": "Consolidate",
	"paid_via": "Paid via",
	"dark": "Dark",
	"light": "Light",
	"copied_to_clipboard": "Copied to your clipboard",

	"direct": "Direct",
	"api": "API",
	"calculo": "Cálculo",

	"semicolon": "Semicolon",
	"pipe": "Pipe",
	"colon": "Colon",
	"slash": "Slash",
	"exclamation_mark": "Exclamation Mark",
	"hyphen": "Hyphen",

	"fixed": "Fixed",
	"variable": "Variable",
	"placeholder": "Placeholder",
	"placeholders": "Placeholders",
	"process": "Process",

	"merchant": "Merchant",
	"razao_social": "Razão Social",
	"default_upper": "DEFAULT",
	"no_results_found": "No results found",
	"copy": "Copy",
	"code": "Code",
	"newPaymentLink": "New Payment Link",
	"using_balance": "Using balance",
	"using_balance_of_cd": "Using balance of CD",
	"balance": "Balance",
	"empty": "Empty",

	"mfa_enable_two_factor": "Enable two-factor authentication (required)",
	"mfa_step1": "Download and install an authenticator app on your phone. We recommend Microsoft Authenticator, Google Authenticator or Duo.",
	"mfa_step2": "Using the app, scan the QR Code below.",
	"mfa_enter_verification": "Enter the code",

	"ipn_title": "IPN History",
	"results_per_page": "Results per page",
	"search_for_ipn": "Search for IPN",
	"search_ipn": "Search IPN",
	"ipn_date": "Date",
	"ipn_session_id": "IPN ID",
	"ipn_status": "Status",
	"ipn_action": "Action",
	"ipn_refresh": "Refresh",
	"ipn_list_unsuccessful": "List all unsuccessful IPNs",
	"ipn_view_resend": "View/Resend IPN",
	"ipn_success": "Success",
	"ipn_fail": "Fail",
	"ipn_not_compliant": "Not Compliant",
	"ipn_resend_ipn": "Resend IPN",
	"ipn_content": "Content",
	"ipn_click_here_to_see": "Click here to see",
	"ipn_operation_successfully": "Request successfully processed!",
	"ipn_url_envio": "IPN URL",

	"payment_title": "History",
	"ui_label_payment": 'Payment',
	"payment_id_hash": "Payment ID",
	"payment_type": "Type",
	"payment_status": "Status",
	"payment_date": "Date",
	"payment_pix_data": "Pix Data",
	"payment_extra_info": "Internal description",
	"payment_amount": "Amount",
	"payment_amount_brl": "Amount (BRL)",
	"payment_fx_amount": "Fx Amount",
	"payment_fx_fix": "Fee",
	"payment_action": "Action",
	"payment_type_payment": "Payment",
	"payment_type_balance": "Transfer",
	"payment_transfer_type": "Transfer type",
	"payment_transfer_deposit": "Deposit",
	"payment_transfer_withdraw": "Withdraw",
	"payment_type_fee": "Fee",
	"payment_status_open": "Requested",
	"payment_status_authorized": "Initiated",
	"payment_status_completed": "Confirmed",
	"payment_status_refunded": "Refunded",
	"payment_status_error": "Error",
	"payment_status_error_initiate": "Error initiate",
	"payment_status_initiated": "Initiated",
	"payment_status_confirmed": "Confirmed",
	"payment_status_processing": "Processing",
	"payment_pix_key": "Pix key",
	"payment_pix_key_type": "Pix key type",
	"payment_pix_code": "Pix code",
	"payment_pix_descriptor": "Descriptor",
	"payment_type_phone": "Phone",
	"payment_type_taxid": "Tax ID",
	"payment_type_email": "E-mail",
	"payment_type_alternative": "Alternative",
	"payment_required_fields": "Please complete the all required fields.",
	"payment_customer_name": "Name",
	"payment_customer_email": "E-mail",
	"payment_customer_address": "Address",
	"payment_customer_id": "ID",
	"payment_customer": "Customer",
	"payment_payment_description": "Payment description",
	"payment_initiate": "Initiate",
	"payment_confirm": "Confirm",
	"payment_beneficiario": "Beneficiary",
	"payment_credit_info": "Credit info",
	"payment_authorization_code": "Authorization code",
	"payment_pix_bank": "Bank",
	"payment_pix_branch": "Branch",
	"payment_pix_account": "Account",
	"payment_pix_name": "Name",
	"payment_pix_taxid": "Tax ID",
	"payment_pix_pix_person_type": "Person type",
	"payment_pix_pix_person_type_business": "Business",
	"payment_pix_pix_person_type_individual": "Individual",
	"payment_pix_transaction_history": "History",
	"payment_cancel": "Cancel",

	"payment_initiation_fee": "Initiation fee",
	"payment_confirmation_fee": "Confirmation fee",
	"payment_refund_fee": "Refund fee",
	"payment_fee": "Fee",
	"payment_fee_brl": "Fee (BRL)",
	"payment_fix": "Fix",
	"payment_fix_brl": "Fix (BRL)",
	"payment_authorization_code": "Authorization code",

	"payment_setting_title": "Payment Settings",
	"payment_settings_active": "Active",
	"payment_settings_balance_brl": "Balance BRL",
	"payment_settings_balance_fx": "Balance FX",
	"payment_settings_minimum_balance": "Minimum Balance FX",
	"payment_settings_webhook_refund": "Refund webhook URL",
	"payment_settings_webhook": "Webhook URL",
	"payment_settings_currency": "Balance currency",
	"payment_settings_remittance_currency": "Remittance currency",

	"payment_settings_config_title": "Payment setting config",
	"payment_settings_config_entry_currency": "Entry currency",
	"payment_settings_config_connector": "Connector",
	"payment_settings_config_acoes": "Action",

	"payment_remittance_title": "Payment Remittance",
	"payment_report_title": "Payment Reports",
	"payment_report_preview": "Preview",
	"payment_report_filters": "Filters",
	"payment_report_filters_clear": "Clear",
	"payment_report_filters_date": "Date",
	"payment_report_select_option": "Select a report option",
	"payment_report_transactions_report": "Transaction report",
	"payment_report_start_date": "Start date",
	"payment_report_end_date": "End date",
	"payment_report_report_preview": "Report preview",
	"payment_report_export_total": "Total to be exported",
	"payment_report_rows": "record(s)",
	"payment_report_empty_rows": "There are no records in this report",
	"payment_report_generate": "Generate CSV",
	"payment_report_created_at": "Submission date",
	"payment_report_id": "Payment ID",
	"payment_report_status": "Status",
	"payment_report_customer_id": "Customer ID",
	"payment_report_customer_name": "Customer name",
	"payment_report_customer_email": "Customer e-mail address",
	"payment_report_customer_address": "Customer address",
	"payment_report_amount_brl_due": "Amount due to be paid in BRL",
	"payment_report_fx_amount_due": "Amount due to be paid in {exchange}",
	"payment_report_amount_brl_paid": "Amount paid in BRL",
	"payment_report_fx_amount_paid": "Amount paid in {exchange}",
	"payment_report_amount_brl_refunded": "Amount refunded in BRL",
	"payment_report_fx_amount_refunded": "Amount refunded in {exchange}",
	"payment_report_fee_brl": "Fee in BRL",
	"payment_report_fee_fx": "Fee in {exchange}",
	"payment_report_fx_rate_id": "FX rate ID",
	"payment_report_fx_rate": "FX rate",
	"payment_report_authorization_code": "Authorization code",
	"payment_report_pix_name": "Recipient name",
	"payment_report_pix_taxid": "Recipient Tax ID",
	"payment_report_pix_person_type": "Recipient person type",
	"payment_report_pix_key": "Recipient Pix key",
	"payment_report_pix_key_type": "Recipient Pix type",
	"payment_report_pix_code": "Recipient Pix code",
	"payment_report_pix_descriptor": "Recipient Pix description",
	"payment_report_pix_bank": "Recipient bank number",
	"payment_report_pix_branch": "Recipient branch number",
	"payment_report_pix_account": "Recipient account number",
	"payment_report_payment_description": "Internal description",
	"payment_report_fx_balance": "Balance in {exchange}",
	"payment_invoice_number": "Invoice Number",

	"resource_integration_manual": "Integration Manual - Payment Methods, PagStream®, Payment Link, Payouts and Reconciliation",
	"resource_cpfcnpj_validation": "Tax ID (CPF/CNPJ) validation routines",
	"resource_payment_method_image": "Payment methods images and logos - June 2021",
	"resource_guide_boleto_flash": "Merchant Guide: Boleto Flash® - June 2021",
	"resource_guide_pix": "Merchant Guide: Pix - June 2021",
	"resource_guide_pec_flash": "Merchant Guide: PEC Flash® - June 2021",
	"resource_guide_pagshield": "Merchant Guide: PagShield Fraud Prevention - June 2021",
	"resource_guide_recurring": "Merchant Guide: Recurring Payments - June 2021",
	"resource_guide_proof_of_delivery": "Merchant Guide: Proof of Delivery - June 2021",
	"resource_guide_customer_support": "Merchant Guide: Customer Support - June 2021",
	"resource_guide_pre_authorized_orders": "Merchant Guide: Manual Review of Pre-Authorized Orders - September 2024",

	"menu_area_assinante_configuracao": "Settings",
	"area_assinante_subdomain_already_taken": "Subdomain already taken",
	"area_assinante_subdomain_invalid_char": "Subdomain contains invalid characters",
	"area_assinante_subdomain": "Subdomain",
	"area_assinante_cor_base": "Login page base color",
	"area_assinante_sombra_login": "Login page shadow color",
	"area_assinante_icone_profile": "Profile icon",
	"area_assinante_cor_barra_superior": "Top bar color",
	"area_assinante_html_botao_cancelamento": "Replace cancel button",
	"area_assinante_logo_pagstream": "Login logo",
	"area_assinante_logo_pagstream_barra": "Top bar logo",
	"area_assinante_seleção_arquivo": "No file chosen",
	"area_assinante_pause": "Pause subscription",
	"area_assinante_activate": "Activate subscription",
	"area_assinante_skip": "Skip next renewal",
	"area_assinante_pause_text": "Text displayed when the customer selects to pause",
	"area_assinante_skip_text": "Text displayed when the customer selects to skip",
	"area_assinante_pausar_assinatura_template": "You can pause your subscription for a period of time that is most convenient for you. It can be for a few weeks or even months, depending on your needs.",
	"area_assinante_pular_assinatura_template": "You can skip the next charge and return to your subscription on the next invoice. We will not charge any additional fees. We want you to have complete freedom to manage your relationship with us.",

	"consolidatedtaxid_order": "Order",
	"consolidatedtaxid_amount_paid": "Amt. paid",
	"consolidatedtaxid_net_amount": "Net amt.",
	"consolidatedtaxid_amount_refunded": "Amt. refunded",
	"consolidatedtaxid_taxid": "TaxId",
	"consolidatedtaxid_name": "Name",
	"consolidatedtaxid_taxid_adjusted": "TaxId Adjusted",
	"consolidatedtaxid_name_adjusted": "Name Adjusted",

	"in": "in",
	"weekly": "Weekly",
	"monthly": "Monthly",
	"quarterly": "Quarterly",
	"semiannually": "Semiannually",
	"yearly": "Yearly",

	"day": "Day",
	"week": "Week",
	"month": "Month",
	"quarter": "Quarter",
	"year": "Year",

	"days": "Days",
	"weeks": "Weeks",
	"months": "Months",
	"quarters": "Quarters",
	"years": "Years",

	"unlimited": "Unlimited",

	"month_jan": "January",
	"month_feb": "February",
	"month_mar": "March",
	"month_apr": "April",
	"month_may": "May",
	"month_jun": "June",
	"month_jul": "July",
	"month_aug": "August",
	"month_sep": "September",
	"month_oct": "October",
	"month_nov": "November",
	"month_dec": "December",

	"errormsg_UrlTransf": "By default we only allow outgoing connections to HTTPS URLs at standard port 443. If you plan to use a different port number in the IPN's URL please contact us requesting an exception.",
	"errormsg_Periodo31Dias": "Please select less than 31 days.",
	"errormsg_31days": "Invalid date. The maximum date range is 31 days.",
	"errormsg_please_filter": "Please filter to see the report.",
	"errormsg_request": "Undefined error occurs.",
	"errormsg_request_file": "An error occurred while generating the file.",
	"errormsg_value_greater_than": "'{0}' must be greater than '{1}'.",
	"errormsg_value_not_zero": "'{0}' must be greater than 0.",
	"warningmsg_perm": "You are not able to change merchants.",

	"errormsg_InicioMenorTermino": "The end date must be lower than begin date.",
	"errormsg_minvencpix": "The minimum value for this field is 1 minute.",
	"errormsg_maxvencpix": "The maximum value for this field is 7200 minutes.",
	"title_vencpix": "Define the number of minutes for the Pix to expire (1 to 7200). This will apply to all of your Pix (NOT including those already issued).",

	"texto_bol_desc": "O campo permite a tag de nova linha &#60;br&#62;",

	"modal_insert_account_gateway_credential": "New Gateway Credential",
	"modal_update_account_gateway_credential": "Update Gateway Credential",
	"account_gateway": "Gateway",
	"account_gateway_order": "Order",
	"account_key": "Key",
	"account_terminal_id": "Terminal ID",
	"account_partner_id": "Partner ID",
	"account_seller_id": "Seller ID",
	"account_homologation": "Homologation",
	"label_user_token_enabled": "Token :",
	"message_token_user_enabled": "Token enabled. Action valid only when clicking the send button.",
	"message_token_user_disabled": "Token disabled. Action valid only when clicking the send button.",
	"super_account_group_description": "Description",
	"super_account_group_prefix_for_card_table": "Prefix for card table",
	"title_error_validation": "Error Validation",
	"super_account_group_empty_fields_error":"Fill in both fields!",
	"super_account_revenue_group_description": "Description",
	"placeholder_revenue_search": "Search group name or number",
	"super_account_group_empty_field_desc":"Fill in the description field!",
	"super_process_fee_title": "Fees Configuration",
	"super_process_fee_grupo" : "Revenue Group",
	"super_process_fee_ativo" : "Active",
	"super_process_fee_faturamento" : "Monthly Revenue (BRL)",
	"super_process_fee_pix" : "Pix Fee",
	"super_process_fee_boleto_flash" : "Boleto Flash Fee",
	"super_process_fee_pec" : "PEC Flash Fee",
	"super_process_fee_boleto_bancario" : "Boleto Bancário Fee",
	"super_process_fee_banking" : "Online Banking Fee",
	"super_process_fee_paypal" : "Paypal Fee",
	"super_process_fee_pagbrasil" : "PagBrasil Intermediation Solution Fee",
	"super_process_fee_pagbrasil_gateway" : "PagBrasil Gateway Solution Fee",
	"super_process_fee_debito" : "Debit Card Fee",
	"super_process_fee_cc_oneoff" : "Credit Card (One off) Fee",
	"super_process_fee_cc_2_to_6" : "Credit Card (Installments 2 to 6) Fee",
	"super_process_fee_cc_7_to_12" : "Credit Card (Installments 7 to 12) Fee",
	"super_process_fee_data" : "Last Review Date",
	"super_process_fee_user" : "Last Modified by",
	"super_process_fee_error_campos" : "Fill all required fields ",
	"super_process_fee_error_delete" : "Unable to delete an active field",
	"super_process_fee_error_update" : "Unable to disable an active field",

	"message_attention_remittance_schedule": "Attention - There are schedules configurated but the remittance schedule is not activated.",
	"message_schedule_remittance_settlement_report": "Schedule remittance",

	"amount_refunded_total_amount": "Total amount",

	"label_wallet": "Wallet",
	"google_pay": "Google Pay",
	"samsung_pay": "Samsung Pay",
	"apple_pay": "Apple Pay",

	"ui_label_mid": "POS history",
	"mid_option_no": "No",
	"mid_option_yes": "Yes",
	"mid_option_yes_with_filter": "Yes, with filter by MID",

	"clone_of": "Clone of",

	"ui_label_block_card_gateway": "Block card",
	"block_card_yes": "Yes",
	"block_card_no": "No",

	"ui_label_fix_additional_channel_dash": "Additional fix Remote channel",
	"ui_label_fee_additional_channel_dash": "Additional fee Remote channel",
	"ui_label_fix_additional_channel_pos": "Additional fix POS channel",
	"ui_label_fee_additional_channel_pos": "Additional fee POS channel",

	"date_format_language": "MM/dd/yyyy",

	"ss_scheduled": "Scheduled",
	"ss_finished": "Processed",
	"ss_unprocessed": "Not processed",

	"tooltip_report": "Report",
	"tooltip_invoice": "Invoice",

	"so_download": "Download",
	"so_filter": "Filter",
	"so_clear": "Clear",

	"client": "Customer",
	"conta_corrente": "Checking Account",
	"conta_salario": "Salary",
	"conta_poupanca": "Savings",
	"conta_transferencia": "Transfer",

	"overview_overview": "Overview",
	"overview_period": "Period",
	"overview_payment_method": "Payment method",
	"overview_invoicing": "Revenue",
	"overview_conversion": "Conversion",
	"overview_latest_completed_orders": "Latest completed orders",
	"overview_last_notices": "Last notices",
	"overview_view_all_notices": "View all notices",
	"overview_date": "Date",
	"overview_order": "Order",
	"overview_orders": "Orders",
	"overview_method": "Method",
	"overview_type": "Type",
	"overview_notice": "Notice",
	"overview_total": "Total",
	"overview_completed": "Completed",
	"overview_filter_by": "Filter by",
	"overview_filter": "Filter",
	"overview_filter_start_date": "Start date",
	"overview_filter_end_date": "End date",
	"overview_filter_all": "All",
	"overview_chart_no_data": "No Data Available",
	"overview_validate_date_error": "The selected interval cannot be greater than 31 days.",
	"overview_currency_brl": "BRL ",

	"trial_search_title": "Search Trial",
	"trial_status_title": "Status",
	"trial_search_code": "Trial Code",
	"trial_search_status_completed": "Completed",
	"trial_search_status_expired": "Expired",
	"trial_search_status_open": "Open",
	"trial_search_status_canceled": "Canceled",
	"trial_search_expiration_date": "Expiration date",
	"trial_search_cancel_date": "Cancel date",

	"pagstream_overview_percentage_tooltip": "Compared to:",
	"pagstream_overview_next_30_days_revenue_tooltip": "Total projected revenue for the next 30 days",
	"pagstream_overview_lifetime_value_tooltip": "Average revenue generated by a customer throughout their relationship with the merchant",
	"pagstream_overview_active_subscriptions_tooltip": "Total number of active subscriptions",

	"pagstream_overview_period": "Period:",
	"pagstream_overview_compare_with": "Compare with:",
	"pagstream_overview_total_revenue": "Total revenue",
	"pagstream_overview_next_30_days_revenue": "Revenue for the next 30 days",
	"pagstream_overview_lifetime_value": "LTV (Lifetime Value)",
	"pagstream_overview_average_ticket": "Average ticket per subscription",
	"pagstream_overview_active_subscriptions": "Active subscriptions",
	"pagstream_overview_new_subscriptions": "New subscriptions",
	"pagstream_overview_retries_revenue": "Revenue recovered with retries",
	"pagstream_overview_pl_revenue": "Revenue recovered with payment link",
	"pagstream_overview_retrieved_orders": "Retrieved orders",
	"pagstream_overview_retrieved_orders_flag": "(Total Payment Link and retries)",
	"pagstream_overview_billing_errors": "Billing errors",
	"pagstream_overview_charge_revenue": "Churn revenue",
	"pagstream_overview_churn_rate": "Churn rate",
	"pagstream_overview_purchase_items": "Most purchased items",
	"pagstream_overview_errors_by_type": "Errors by type",
	"pagstream_overview_cancellation_reasons": "Reasons for cancellation",

	"cost_config_date": "Effective Date",
	"cost_config_bank": "Bank",
	"cost_config_adquirente": "Acquirer",
	"cost_config_mcc": "MCC",
	"cost_config_brand": "Brand",
	"cost_config_installments": "Installments",
	"cost_config_installments_2a6": "Installments 2 to 6",
	"cost_config_installments_7a12": "Installments 7 to 12",

	"posregister_id": "Id",
	"posregister_pos_id": "POS Id",
	"posregister_email": "E-mail",
	"posregister_active": "Active",

	"nupay_type_translate_credit": "Credit",
	"nupay_type_translate_debit": "Debit",

	"required_fields_error": "Please fill all the required fields!",
	"tax_id_invalid": "Please check the CPF/CNPJ provided",
	
	"modelocontrato_title": "Contract Models",
	"modelocontrato_form_description": "Description",

	"nome_contrato_coluna": "Contract file name",
	"modelo_contrato_coluna": "Contract model",
	"modelo_contrato_placeholder": "Select a model",
	"data_inicial_revisao_coluna": "Initial revision date",
	"troca_faixa_ativa": "This group's range needs to be reviewed.",
    "troca_faixa_inativa": "Awaiting initial date for review.",

	"revenue_group_history_title": "Modification history",
	"label_pix_automatico_fee": "Automatic Pix Fee",
	"label_pix_automatico_fix": "Automatic Pix Fix",
	"label_approved_consent_fix": "Approved Consent Fix",
	"label_ui_pix_automatico": "Automatic Pix",
	"label_ui_pix_automatico_retry_auto": "Automatic Pix Retry",
	"pix_automatico_retry_auto_on_demand": "On demand",
	"pix_automatico_retry_auto_automatic": "Automatic",

	"translate_pix_cycle_weekly": "Weekly",
	"translate_pix_cycle_monthly": "Monthly",
	"translate_pix_cycle_quarterly": "Quarterly",
	"translate_pix_cycle_semiannual": "Semiannual",
	"translate_pix_cycle_annually": "Annually",
	"label_ui_pix_automatico_consents": "Automatic Pix consents",
	"btn_pix_automatico_consents": "Check Authorizations",
	"modal_pix_consents_title": "Consent History",

	"pix_auto_label_id": "Pix Rec. ID",
	"pix_auto_label_name": "Payer name",
	"pix_auto_label_taxid": "Payer Tax ID",
	"pix_auto_label_first_rec": "First recurrence date",
	"pix_auto_label_status": "Status",
	"pix_auto_label_status_autorizado": "Authorized",
	"pix_auto_label_status_cancelado": "Canceled",
	"pix_auto_label_status_pendente": "Not initiated",
	"pix_auto_label_status_desautorizado": "Unauthorized",
	"pix_auto_label_empty": "No consent found.",

	"pix_auto_label_retry": "Retry",
	"pix_auto_label_retry_not_allowed": "Not allowed",
	"pix_auto_label_retry_allowed": "Active",

	"pix_auto_label_taxid_placeholder": "Search by tax ID",
	"pix_auto_label_name_placeholder": "Search by payer's name",
	"pix_auto_label_id_placeholder": "Search by recurrence ID",
}

export default en
